"use strict";
(self.webpackChunkrstlWebpackJsonp =
  self.webpackChunkrstlWebpackJsonp || []).push([
  [180],
  {
    946: (e, t, n) => {
      function i(e, t, n) {
        return Array.prototype.slice.call(e, t, n);
      }
      function r(e) {
        return e.bind.apply(e, [null].concat(i(arguments, 1)));
      }
      function o(e) {
        return requestAnimationFrame(e);
      }
      function a(e, t) {
        return typeof t === e;
      }
      n.d(t, { Z: () => Y });
      var s = Array.isArray;
      function u(e) {
        return s(e) ? e : [e];
      }
      function c(e, t) {
        u(e).forEach(t);
      }
      (r(a, "function"), r(a, "string"), r(a, "undefined"));
      var l = Object.keys;
      function d(e) {
        return (
          i(arguments, 1).forEach(function (t) {
            !(function (e, t, n) {
              if (e) {
                var i = l(e);
                i = n ? i.reverse() : i;
                for (var r = 0; r < i.length; r++) {
                  var o = i[r];
                  if ("__proto__" !== o && !1 === t(e[o], o)) break;
                }
              }
            })(t, function (n, i) {
              e[i] = t[i];
            });
          }),
          e
        );
      }
      var f = Math.min;
      var h = "move",
        p = "moved",
        v = "updated",
        y = "drag",
        m = "dragged",
        g = "scroll",
        b = "scrolled",
        w = "destroy";
      function E(e) {
        var t = e ? e.event.bus : document.createDocumentFragment(),
          n = (function () {
            var e = [];
            function t(e, t, n) {
              c(e, function (e) {
                e &&
                  c(t, function (t) {
                    t.split(" ").forEach(function (t) {
                      var i = t.split(".");
                      n(e, i[0], i[1]);
                    });
                  });
              });
            }
            return {
              bind: function (n, i, r, o) {
                t(n, i, function (t, n, i) {
                  var a = "addEventListener" in t,
                    s = a
                      ? t.removeEventListener.bind(t, n, r, o)
                      : t.removeListener.bind(t, r);
                  (a ? t.addEventListener(n, r, o) : t.addListener(r),
                    e.push([t, n, i, r, s]));
                });
              },
              unbind: function (n, i, r) {
                t(n, i, function (t, n, i) {
                  e = e.filter(function (e) {
                    return (
                      !!(
                        e[0] !== t ||
                        e[1] !== n ||
                        e[2] !== i ||
                        (r && e[3] !== r)
                      ) || (e[4](), !1)
                    );
                  });
                });
              },
              dispatch: function (e, t, n) {
                var i,
                  r = !0;
                return (
                  "function" == typeof CustomEvent
                    ? (i = new CustomEvent(t, { bubbles: r, detail: n }))
                    : (i = document.createEvent("CustomEvent")).initCustomEvent(
                        t,
                        r,
                        !1,
                        n,
                      ),
                  e.dispatchEvent(i),
                  i
                );
              },
              destroy: function () {
                (e.forEach(function (e) {
                  e[4]();
                }),
                  (e.length = 0));
              },
            };
          })();
        return (
          e && e.event.on(w, n.destroy),
          d(n, {
            bus: t,
            on: function (e, i) {
              n.bind(t, u(e).join(" "), function (e) {
                i.apply(i, s(e.detail) ? e.detail : []);
              });
            },
            off: r(n.unbind, t),
            emit: function (e) {
              n.dispatch(t, e, i(arguments, 1));
            },
          })
        );
      }
      function k(e, t, n, i) {
        var r,
          a,
          s = Date.now,
          u = 0,
          c = !0,
          l = 0;
        function d() {
          if (!c) {
            if (
              ((u = e ? f((s() - r) / e, 1) : 1),
              n && n(u),
              u >= 1 && (t(), (r = s()), i && ++l >= i))
            )
              return h();
            o(d);
          }
        }
        function h() {
          c = !0;
        }
        function p() {
          (a && cancelAnimationFrame(a), (u = 0), (a = 0), (c = !0));
        }
        return {
          start: function (t) {
            (!t && p(), (r = s() - (t ? u * e : 0)), (c = !1), o(d));
          },
          rewind: function () {
            ((r = s()), (u = 0), n && n(u));
          },
          pause: h,
          cancel: p,
          set: function (t) {
            e = t;
          },
          isPaused: function () {
            return c;
          },
        };
      }
      var P = "is-active",
        S = "slide",
        _ = "fade";
      function C(e, t, n) {
        return Array.prototype.slice.call(e, t, n);
      }
      function x(e) {
        return e.bind(null, ...C(arguments, 1));
      }
      function A(e, t) {
        return typeof t === e;
      }
      function T(e) {
        return !N(e) && A("object", e);
      }
      const L = Array.isArray;
      (x(A, "function"), x(A, "string"));
      const M = x(A, "undefined");
      function N(e) {
        return null === e;
      }
      function F(e, t) {
        var n;
        ((n = e), L(n) ? n : [n]).forEach(t);
      }
      const I = Object.keys;
      function O(e, t, n) {
        if (e) {
          let i = I(e);
          i = n ? i.reverse() : i;
          for (let n = 0; n < i.length; n++) {
            const r = i[n];
            if ("__proto__" !== r && !1 === t(e[r], r)) break;
          }
        }
        return e;
      }
      function j(e) {
        return (
          C(arguments, 1).forEach((t) => {
            O(t, (n, i) => {
              e[i] = t[i];
            });
          }),
          e
        );
      }
      function R(e, t, n) {
        T(t)
          ? O(t, (t, n) => {
              R(e, n, t);
            })
          : F(e, (e) => {
              N(n) || "" === n
                ? (function (e, t) {
                    F(e, (e) => {
                      F(t, (t) => {
                        e && e.removeAttribute(t);
                      });
                    });
                  })(e, t)
                : e.setAttribute(t, String(n));
            });
      }
      const { min: V, max: D, floor: z, ceil: q, abs: W } = Math;
      const B = { speed: 1, autoStart: !0, pauseOnHover: !0, pauseOnFocus: !0 },
        $ = {
          startScroll: "Start auto scroll",
          pauseScroll: "Pause auto scroll",
        };
      function Y(e, t, n) {
        const { on: i, off: r, bind: o, unbind: a } = E(e),
          { translate: s, getPosition: u, toIndex: c, getLimit: l } = t.Move,
          { setIndex: d, getIndex: f } = t.Controller,
          { orient: w } = t.Direction,
          { toggle: C } = t.Elements,
          { Live: x } = t,
          { root: A } = e,
          L = (function (e, t) {
            var n;
            return function () {
              n ||
                (n = k(
                  t || 0,
                  function () {
                    (e(), (n = null));
                  },
                  null,
                  1,
                )).start();
            };
          })(t.Arrows.update, 500);
        let N,
          I,
          O,
          z,
          q,
          W,
          Y = {};
        function H() {
          e.is(_) ||
            N ||
            !1 === n.autoScroll ||
            ((N = k(0, K)),
            (function () {
              Y.pauseOnHover &&
                o(A, "mouseenter mouseleave", (e) => {
                  ((O = "mouseenter" === e.type), Q());
                });
              Y.pauseOnFocus &&
                o(A, "focusin focusout", (e) => {
                  ((z = "focusin" === e.type), Q());
                });
              Y.useToggleButton &&
                o(C, "click", () => {
                  I ? G() : J();
                });
              (i(v, X),
                i([h, y, g], () => {
                  ((q = !0), J(!1));
                }),
                i([p, m, b], () => {
                  ((q = !1), Q());
                }));
            })(),
            Y.autoStart &&
              ("complete" === document.readyState
                ? G()
                : o(window, "load", G)));
        }
        function U() {
          N &&
            (N.cancel(),
            (N = null),
            (W = void 0),
            r([h, y, g, p, b]),
            a(A, "mouseenter mouseleave focusin focusout"),
            a(C, "click"));
        }
        function X() {
          const { autoScroll: e } = n;
          (!1 !== e ? ((Y = j({}, Y, T(e) ? e : {})), H()) : U(),
            N && !M(W) && s(W));
        }
        function G() {
          ee() && (N.start(!0), x.disable(!0), (z = O = I = !1), Z());
        }
        function J(e = !0) {
          I || ((I = e), Z(), ee() || (N.pause(), x.disable(!1)));
        }
        function Q() {
          I || (O || z || q ? J(!1) : G());
        }
        function K() {
          const i = u(),
            r = (function (t) {
              const n = Y.speed || 1;
              ((t += w(n)),
                e.is(S) &&
                  (t = (function (e, t, n) {
                    const i = V(t, n),
                      r = D(t, n);
                    return V(D(i, e), r);
                  })(t, l(!1), l(!0))));
              return t;
            })(i);
          (i !== r
            ? (s(r),
              (function (i) {
                const { length: r } = e,
                  o = (c(i) + r) % r;
                o !== f() &&
                  (d(o),
                  t.Slides.update(),
                  t.Pagination.update(),
                  "nearby" === n.lazyLoad && t.LazyLoad.check());
              })((W = u())))
            : (J(!1),
              Y.rewind && e.go(Y.speed > 0 ? 0 : t.Controller.getEnd())),
            L());
        }
        function Z() {
          if (C) {
            const r = I ? "startScroll" : "pauseScroll";
            ((t = P),
              (i = !I),
              (e = C) &&
                F(t, (t) => {
                  t && e.classList[i ? "add" : "remove"](t);
                }),
              R(C, "aria-label", n.i18n[r] || $[r]));
          }
          var e, t, i;
        }
        function ee() {
          return !N || N.isPaused();
        }
        return {
          setup: function () {
            const { autoScroll: e } = n;
            Y = j({}, B, T(e) ? e : {});
          },
          mount: H,
          destroy: U,
          play: G,
          pause: J,
          isPaused: ee,
        };
      }
    },
    904: (e, t, n) => {
      function i(e, t, n) {
        return Array.prototype.slice.call(e, t, n);
      }
      function r(e) {
        return e.bind.apply(e, [null].concat(i(arguments, 1)));
      }
      function o(e, t) {
        return typeof t === e;
      }
      n.d(t, { U: () => w });
      var a = Array.isArray;
      function s(e) {
        return a(e) ? e : [e];
      }
      function u(e, t) {
        s(e).forEach(t);
      }
      (r(o, "function"), r(o, "string"), r(o, "undefined"));
      var c = Object.keys;
      function l(e) {
        return (
          i(arguments, 1).forEach(function (t) {
            !(function (e, t, n) {
              if (e) {
                var i = c(e);
                i = n ? i.reverse() : i;
                for (var r = 0; r < i.length; r++) {
                  var o = i[r];
                  if ("__proto__" !== o && !1 === t(e[o], o)) break;
                }
              }
            })(t, function (n, i) {
              e[i] = t[i];
            });
          }),
          e
        );
      }
      var d = "destroy";
      function f(e) {
        var t = e ? e.event.bus : document.createDocumentFragment(),
          n = (function () {
            var e = [];
            function t(e, t, n) {
              u(e, function (e) {
                e &&
                  u(t, function (t) {
                    t.split(" ").forEach(function (t) {
                      var i = t.split(".");
                      n(e, i[0], i[1]);
                    });
                  });
              });
            }
            return {
              bind: function (n, i, r, o) {
                t(n, i, function (t, n, i) {
                  var a = "addEventListener" in t,
                    s = a
                      ? t.removeEventListener.bind(t, n, r, o)
                      : t.removeListener.bind(t, r);
                  (a ? t.addEventListener(n, r, o) : t.addListener(r),
                    e.push([t, n, i, r, s]));
                });
              },
              unbind: function (n, i, r) {
                t(n, i, function (t, n, i) {
                  e = e.filter(function (e) {
                    return (
                      !!(
                        e[0] !== t ||
                        e[1] !== n ||
                        e[2] !== i ||
                        (r && e[3] !== r)
                      ) || (e[4](), !1)
                    );
                  });
                });
              },
              dispatch: function (e, t, n) {
                var i,
                  r = !0;
                return (
                  "function" == typeof CustomEvent
                    ? (i = new CustomEvent(t, { bubbles: r, detail: n }))
                    : (i = document.createEvent("CustomEvent")).initCustomEvent(
                        t,
                        r,
                        !1,
                        n,
                      ),
                  e.dispatchEvent(i),
                  i
                );
              },
              destroy: function () {
                (e.forEach(function (e) {
                  e[4]();
                }),
                  (e.length = 0));
              },
            };
          })();
        return (
          e && e.event.on(d, n.destroy),
          l(n, {
            bus: t,
            on: function (e, i) {
              n.bind(t, s(e).join(" "), function (e) {
                i.apply(i, a(e.detail) ? e.detail : []);
              });
            },
            off: r(n.unbind, t),
            emit: function (e) {
              n.dispatch(t, e, i(arguments, 1));
            },
          })
        );
      }
      function h(e) {
        return e.bind(
          null,
          ...((t = arguments), (n = 1), Array.prototype.slice.call(t, n, i)),
        );
        var t, n, i;
      }
      function p(e, t) {
        return typeof t === e;
      }
      (h(p, "function"), h(p, "string"));
      const v = h(p, "undefined"),
        y = Object.keys;
      const m = "intersection",
        g = "intersection:in",
        b = "intersection:out";
      function w(e, t, n) {
        const { emit: i } = f(e),
          r = n.intersection || {},
          o = (function (e) {
            const { Components: t } = e;
            return {
              keyboard: {
                enable() {
                  t.Keyboard.disable(!1);
                },
                disable() {
                  t.Keyboard.disable(!0);
                },
              },
              autoplay: {
                enable() {
                  e.options.autoplay && t.Autoplay.play();
                },
                disable() {
                  t.Autoplay.pause();
                },
              },
              autoScroll: {
                enable() {
                  const e = t.AutoScroll;
                  e && e.play();
                },
                disable() {
                  const e = t.AutoScroll;
                  e && e.pause();
                },
              },
              video: {
                enable() {
                  const e = t.Video;
                  e && e.play();
                },
                disable() {
                  const e = t.Video;
                  e && e.pause();
                },
              },
            };
          })(e);
        let a;
        function s() {
          a && (a.disconnect(), (a = null));
        }
        function u([e]) {
          e &&
            (e.isIntersecting
              ? (function (e) {
                  (c(r.inView || {}), i(g, e), r.once && s());
                })(e)
              : (function (e) {
                  (c(r.outView || {}), i(b, e));
                })(e),
            i(m, e));
        }
        function c(e) {
          !(function (e, t, n) {
            if (e) {
              let i = y(e);
              i = n ? i.reverse() : i;
              for (let n = 0; n < i.length; n++) {
                const r = i[n];
                if ("__proto__" !== r && !1 === t(e[r], r)) break;
              }
            }
          })(e, (e, t) => {
            if (!v(e)) {
              const n = o[t];
              e ? n.enable() : n.disable();
            }
          });
        }
        return {
          mount: function () {
            window.IntersectionObserver &&
              ((a = new IntersectionObserver(u, {
                root: r.root,
                rootMargin: r.rootMargin,
                threshold: r.threshold,
              })),
              a.observe(e.root));
          },
          destroy: s,
        };
      }
    },
    486: (e, t, n) => {
      function i(e, t, n) {
        return Array.prototype.slice.call(e, t, n);
      }
      function r(e) {
        return e.bind.apply(e, [null].concat(i(arguments, 1)));
      }
      function o(e, t) {
        return typeof t === e;
      }
      n.d(t, { C: () => Te });
      var a = Array.isArray;
      function s(e) {
        return a(e) ? e : [e];
      }
      function u(e, t) {
        s(e).forEach(t);
      }
      (r(o, "function"), r(o, "string"), r(o, "undefined"));
      var c = Object.keys;
      function l(e) {
        return (
          i(arguments, 1).forEach(function (t) {
            !(function (e, t, n) {
              if (e) {
                var i = c(e);
                i = n ? i.reverse() : i;
                for (var r = 0; r < i.length; r++) {
                  var o = i[r];
                  if ("__proto__" !== o && !1 === t(e[o], o)) break;
                }
              }
            })(t, function (n, i) {
              e[i] = t[i];
            });
          }),
          e
        );
      }
      var d = "dragging",
        f = "destroy";
      function h(e) {
        var t = e ? e.event.bus : document.createDocumentFragment(),
          n = (function () {
            var e = [];
            function t(e, t, n) {
              u(e, function (e) {
                e &&
                  u(t, function (t) {
                    t.split(" ").forEach(function (t) {
                      var i = t.split(".");
                      n(e, i[0], i[1]);
                    });
                  });
              });
            }
            return {
              bind: function (n, i, r, o) {
                t(n, i, function (t, n, i) {
                  var a = "addEventListener" in t,
                    s = a
                      ? t.removeEventListener.bind(t, n, r, o)
                      : t.removeListener.bind(t, r);
                  (a ? t.addEventListener(n, r, o) : t.addListener(r),
                    e.push([t, n, i, r, s]));
                });
              },
              unbind: function (n, i, r) {
                t(n, i, function (t, n, i) {
                  e = e.filter(function (e) {
                    return (
                      !!(
                        e[0] !== t ||
                        e[1] !== n ||
                        e[2] !== i ||
                        (r && e[3] !== r)
                      ) || (e[4](), !1)
                    );
                  });
                });
              },
              dispatch: function (e, t, n) {
                var i,
                  r = !0;
                return (
                  "function" == typeof CustomEvent
                    ? (i = new CustomEvent(t, { bubbles: r, detail: n }))
                    : (i = document.createEvent("CustomEvent")).initCustomEvent(
                        t,
                        r,
                        !1,
                        n,
                      ),
                  e.dispatchEvent(i),
                  i
                );
              },
              destroy: function () {
                (e.forEach(function (e) {
                  e[4]();
                }),
                  (e.length = 0));
              },
            };
          })();
        return (
          e && e.event.on(f, n.destroy),
          l(n, {
            bus: t,
            on: function (e, i) {
              n.bind(t, s(e).join(" "), function (e) {
                i.apply(i, a(e.detail) ? e.detail : []);
              });
            },
            off: r(n.unbind, t),
            emit: function (e) {
              n.dispatch(t, e, i(arguments, 1));
            },
          })
        );
      }
      var p = "splide__slide",
        v = p + "__container";
      function y(e, t, n) {
        return Array.prototype.slice.call(e, t, n);
      }
      function m(e) {
        return e.bind(null, ...y(arguments, 1));
      }
      function g(e, t) {
        return typeof t === e;
      }
      function b(e) {
        return !S(e) && g("object", e);
      }
      const w = Array.isArray,
        E = m(g, "function"),
        k = m(g, "string"),
        P = m(g, "undefined");
      function S(e) {
        return null === e;
      }
      function _(e, t) {
        var n;
        ((n = e), w(n) ? n : [n]).forEach(t);
      }
      function C(e, t, n) {
        e &&
          _(t, (t) => {
            t && e.classList[n ? "add" : "remove"](t);
          });
      }
      function x(e, t) {
        C(e, k(t) ? t.split(" ") : t, !0);
      }
      function A(e, t) {
        return (
          e instanceof HTMLElement &&
          (e.msMatchesSelector || e.matches).call(e, t)
        );
      }
      function T(e, t) {
        return t
          ? (function (e, t) {
              const n = e ? y(e.children) : [];
              return t ? n.filter((e) => A(e, t)) : n;
            })(e, t)[0]
          : e.firstElementChild;
      }
      const L = Object.keys;
      function M(e, t, n) {
        if (e) {
          let i = L(e);
          i = n ? i.reverse() : i;
          for (let n = 0; n < i.length; n++) {
            const r = i[n];
            if ("__proto__" !== r && !1 === t(e[r], r)) break;
          }
        }
        return e;
      }
      function N(e) {
        return (
          y(arguments, 1).forEach((t) => {
            M(t, (n, i) => {
              e[i] = t[i];
            });
          }),
          e
        );
      }
      function F(e) {
        return (
          y(arguments, 1).forEach((t) => {
            M(t, (t, n) => {
              w(t)
                ? (e[n] = t.slice())
                : b(t)
                  ? (e[n] = F({}, b(e[n]) ? e[n] : {}, t))
                  : (e[n] = t);
            });
          }),
          e
        );
      }
      function I(e, t, n) {
        b(t)
          ? M(t, (t, n) => {
              I(e, n, t);
            })
          : _(e, (e) => {
              S(n) || "" === n
                ? (function (e, t) {
                    _(e, (e) => {
                      _(t, (t) => {
                        e && e.removeAttribute(t);
                      });
                    });
                  })(e, t)
                : e.setAttribute(t, String(n));
            });
      }
      function O(e, t, n) {
        const i = document.createElement(e);
        return (
          t && (k(t) ? x(i, t) : I(i, t)),
          n &&
            (function (e, t) {
              _(t, e.appendChild.bind(e));
            })(n, i),
          i
        );
      }
      function j(e, t) {
        !(function (e, t, n) {
          if (P(n)) return getComputedStyle(e)[t];
          S(n) || (e.style[t] = `${n}`);
        })(e, "display", t);
      }
      function R(e, t) {
        C(e, t, !1);
      }
      const { min: V, max: D, floor: z, ceil: q, abs: W } = Math;
      function B(e, t, n) {
        const i = V(t, n),
          r = D(t, n);
        return V(D(i, e), r);
      }
      const $ = "splide__video",
        Y = `${$}__wrapper`,
        H = `${$}__play`,
        U = "--has-video",
        X = { hideControls: !1, loop: !1, mute: !1, volume: 0.2 },
        G = "video:click";
      class J {
        constructor(e, t, n) {
          var i;
          ((this.state =
            ((i = 1),
            {
              set: function (e) {
                i = e;
              },
              is: function (e) {
                return ((t = s(e)), (n = i), t.indexOf(n) > -1);
                var t, n;
              },
            })),
            (this.event = h()),
            (this.target = e),
            (this.videoId = t),
            (this.options = n || {}),
            (this.onPlay = this.onPlay.bind(this)),
            (this.onPause = this.onPause.bind(this)),
            (this.onEnded = this.onEnded.bind(this)),
            (this.onPlayerReady = this.onPlayerReady.bind(this)),
            (this.onError = this.onError.bind(this)));
        }
        on(e, t) {
          this.event.on(e, t);
        }
        play() {
          const { state: e } = this;
          if (!e.is(9))
            return (
              this.event.emit("play"),
              e.is(2)
                ? e.set(4)
                : e.is(3)
                  ? ((this.player = this.createPlayer(this.videoId)), e.set(4))
                  : void (
                      e.is([4, 8]) ||
                      (e.is(5) && (e.set(6), this.playVideo()))
                    )
            );
        }
        pause() {
          const { state: e } = this;
          if (!e.is(9))
            return (
              this.event.emit("pause"),
              e.is(4)
                ? e.set(2)
                : e.is(6)
                  ? e.set(7)
                  : void (e.is(8) && (this.pauseVideo(), this.state.set(5)))
            );
        }
        isPaused() {
          return !this.state.is(8);
        }
        destroy() {
          this.event.destroy();
        }
        onPlayerReady() {
          const { state: e } = this,
            t = e.is(4);
          (e.set(5), t && this.play());
        }
        onPlay() {
          const { state: e } = this,
            t = e.is(7);
          (e.set(8), t ? this.pause() : this.event.emit("played"));
        }
        onPause() {
          (this.state.set(5), this.event.emit("paused"));
        }
        onEnded() {
          (this.state.set(5), this.event.emit("ended"));
        }
        onError() {
          (this.state.set(9), this.event.emit("error"));
        }
      }
      function Q(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          ((i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i));
        }
      }
      var K = void 0 !== n.g && "[object global]" === {}.toString.call(n.g);
      function Z(e, t) {
        return 0 === e.indexOf(t.toLowerCase())
          ? e
          : ""
              .concat(t.toLowerCase())
              .concat(e.substr(0, 1).toUpperCase())
              .concat(e.substr(1));
      }
      function ee(e) {
        return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(e);
      }
      function te() {
        var e,
          t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = t.id,
          i = t.url,
          r = n || i;
        if (!r)
          throw new Error(
            "An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.",
          );
        if (
          ((e = r), !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e)
        )
          return "https://vimeo.com/".concat(r);
        if (ee(r)) return r.replace("http:", "https:");
        if (n) throw new TypeError("“".concat(n, "” is not a valid video id."));
        throw new TypeError("“".concat(r, "” is not a vimeo.com url."));
      }
      var ne = void 0 !== Array.prototype.indexOf,
        ie = "undefined" != typeof window && void 0 !== window.postMessage;
      if (!(K || (ne && ie)))
        throw new Error(
          "Sorry, the Vimeo Player API is not available in this browser.",
        );
      var re =
        "undefined" != typeof globalThis
          ? globalThis
          : "undefined" != typeof window
            ? window
            : void 0 !== n.g
              ? n.g
              : "undefined" != typeof self
                ? self
                : {};
      !(function (e) {
        if (!e.WeakMap) {
          var t = Object.prototype.hasOwnProperty,
            n =
              Object.defineProperty &&
              (function () {
                try {
                  return 1 === Object.defineProperty({}, "x", { value: 1 }).x;
                } catch (e) {}
              })(),
            i = function (e, t, i) {
              n
                ? Object.defineProperty(e, t, {
                    configurable: !0,
                    writable: !0,
                    value: i,
                  })
                : (e[t] = i);
            };
          e.WeakMap = (function () {
            function e() {
              if (void 0 === this)
                throw new TypeError("Constructor WeakMap requires 'new'");
              if (
                (i(this, "_id", "_WeakMap" + "_" + o() + "." + o()),
                arguments.length > 0)
              )
                throw new TypeError("WeakMap iterable is not supported");
            }
            function n(e, n) {
              if (!r(e) || !t.call(e, "_id"))
                throw new TypeError(
                  n + " method called on incompatible receiver " + typeof e,
                );
            }
            function o() {
              return Math.random().toString().substring(2);
            }
            return (
              i(e.prototype, "delete", function (e) {
                if ((n(this, "delete"), !r(e))) return !1;
                var t = e[this._id];
                return !(!t || t[0] !== e) && (delete e[this._id], !0);
              }),
              i(e.prototype, "get", function (e) {
                if ((n(this, "get"), r(e))) {
                  var t = e[this._id];
                  return t && t[0] === e ? t[1] : void 0;
                }
              }),
              i(e.prototype, "has", function (e) {
                if ((n(this, "has"), !r(e))) return !1;
                var t = e[this._id];
                return !(!t || t[0] !== e);
              }),
              i(e.prototype, "set", function (e, t) {
                if ((n(this, "set"), !r(e)))
                  throw new TypeError("Invalid value used as weak map key");
                var o = e[this._id];
                return o && o[0] === e
                  ? ((o[1] = t), this)
                  : (i(e, this._id, [e, t]), this);
              }),
              i(e, "_polyfill", !0),
              e
            );
          })();
        }
        function r(e) {
          return Object(e) === e;
        }
      })(
        "undefined" != typeof globalThis
          ? globalThis
          : "undefined" != typeof self
            ? self
            : "undefined" != typeof window
              ? window
              : re,
      );
      var oe,
        ae,
        se =
          ((oe = function (e) {
            var t, n, i;
            ((i = function () {
              var e,
                t,
                n,
                i = Object.prototype.toString,
                r =
                  "undefined" != typeof setImmediate
                    ? function (e) {
                        return setImmediate(e);
                      }
                    : setTimeout;
              try {
                (Object.defineProperty({}, "x", {}),
                  (e = function (e, t, n, i) {
                    return Object.defineProperty(e, t, {
                      value: n,
                      writable: !0,
                      configurable: !1 !== i,
                    });
                  }));
              } catch (t) {
                e = function (e, t, n) {
                  return ((e[t] = n), e);
                };
              }
              function o(e, i) {
                (n.add(e, i), t || (t = r(n.drain)));
              }
              function a(e) {
                var t,
                  n = typeof e;
                return (
                  null == e ||
                    ("object" != n && "function" != n) ||
                    (t = e.then),
                  "function" == typeof t && t
                );
              }
              function s() {
                for (var e = 0; e < this.chain.length; e++)
                  u(
                    this,
                    1 === this.state
                      ? this.chain[e].success
                      : this.chain[e].failure,
                    this.chain[e],
                  );
                this.chain.length = 0;
              }
              function u(e, t, n) {
                var i, r;
                try {
                  !1 === t
                    ? n.reject(e.msg)
                    : (i = !0 === t ? e.msg : t.call(void 0, e.msg)) ===
                        n.promise
                      ? n.reject(TypeError("Promise-chain cycle"))
                      : (r = a(i))
                        ? r.call(i, n.resolve, n.reject)
                        : n.resolve(i);
                } catch (e) {
                  n.reject(e);
                }
              }
              function c(e) {
                var t,
                  n = this;
                if (!n.triggered) {
                  ((n.triggered = !0), n.def && (n = n.def));
                  try {
                    (t = a(e))
                      ? o(function () {
                          var i = new f(n);
                          try {
                            t.call(
                              e,
                              function () {
                                c.apply(i, arguments);
                              },
                              function () {
                                l.apply(i, arguments);
                              },
                            );
                          } catch (e) {
                            l.call(i, e);
                          }
                        })
                      : ((n.msg = e),
                        (n.state = 1),
                        n.chain.length > 0 && o(s, n));
                  } catch (e) {
                    l.call(new f(n), e);
                  }
                }
              }
              function l(e) {
                var t = this;
                t.triggered ||
                  ((t.triggered = !0),
                  t.def && (t = t.def),
                  (t.msg = e),
                  (t.state = 2),
                  t.chain.length > 0 && o(s, t));
              }
              function d(e, t, n, i) {
                for (var r = 0; r < t.length; r++)
                  !(function (r) {
                    e.resolve(t[r]).then(function (e) {
                      n(r, e);
                    }, i);
                  })(r);
              }
              function f(e) {
                ((this.def = e), (this.triggered = !1));
              }
              function h(e) {
                ((this.promise = e),
                  (this.state = 0),
                  (this.triggered = !1),
                  (this.chain = []),
                  (this.msg = void 0));
              }
              function p(e) {
                if ("function" != typeof e) throw TypeError("Not a function");
                if (0 !== this.__NPO__) throw TypeError("Not a promise");
                this.__NPO__ = 1;
                var t = new h(this);
                ((this.then = function (e, n) {
                  var i = {
                    success: "function" != typeof e || e,
                    failure: "function" == typeof n && n,
                  };
                  return (
                    (i.promise = new this.constructor(function (e, t) {
                      if ("function" != typeof e || "function" != typeof t)
                        throw TypeError("Not a function");
                      ((i.resolve = e), (i.reject = t));
                    })),
                    t.chain.push(i),
                    0 !== t.state && o(s, t),
                    i.promise
                  );
                }),
                  (this.catch = function (e) {
                    return this.then(void 0, e);
                  }));
                try {
                  e.call(
                    void 0,
                    function (e) {
                      c.call(t, e);
                    },
                    function (e) {
                      l.call(t, e);
                    },
                  );
                } catch (e) {
                  l.call(t, e);
                }
              }
              n = (function () {
                var e, n, i;
                function r(e, t) {
                  ((this.fn = e), (this.self = t), (this.next = void 0));
                }
                return {
                  add: function (t, o) {
                    ((i = new r(t, o)),
                      n ? (n.next = i) : (e = i),
                      (n = i),
                      (i = void 0));
                  },
                  drain: function () {
                    var i = e;
                    for (e = n = t = void 0; i;)
                      (i.fn.call(i.self), (i = i.next));
                  },
                };
              })();
              var v = e({}, "constructor", p, !1);
              return (
                (p.prototype = v),
                e(v, "__NPO__", 0, !1),
                e(p, "resolve", function (e) {
                  return e && "object" == typeof e && 1 === e.__NPO__
                    ? e
                    : new this(function (t, n) {
                        if ("function" != typeof t || "function" != typeof n)
                          throw TypeError("Not a function");
                        t(e);
                      });
                }),
                e(p, "reject", function (e) {
                  return new this(function (t, n) {
                    if ("function" != typeof t || "function" != typeof n)
                      throw TypeError("Not a function");
                    n(e);
                  });
                }),
                e(p, "all", function (e) {
                  var t = this;
                  return "[object Array]" != i.call(e)
                    ? t.reject(TypeError("Not an array"))
                    : 0 === e.length
                      ? t.resolve([])
                      : new t(function (n, i) {
                          if ("function" != typeof n || "function" != typeof i)
                            throw TypeError("Not a function");
                          var r = e.length,
                            o = Array(r),
                            a = 0;
                          d(
                            t,
                            e,
                            function (e, t) {
                              ((o[e] = t), ++a === r && n(o));
                            },
                            i,
                          );
                        });
                }),
                e(p, "race", function (e) {
                  var t = this;
                  return "[object Array]" != i.call(e)
                    ? t.reject(TypeError("Not an array"))
                    : new t(function (n, i) {
                        if ("function" != typeof n || "function" != typeof i)
                          throw TypeError("Not a function");
                        d(
                          t,
                          e,
                          function (e, t) {
                            n(t);
                          },
                          i,
                        );
                      });
                }),
                p
              );
            }),
              ((n = re)[(t = "Promise")] = n[t] || i()),
              e.exports && (e.exports = n[t]));
          }),
          oe((ae = { exports: {} }), ae.exports),
          ae.exports),
        ue = new WeakMap();
      function ce(e, t, n) {
        var i = ue.get(e.element) || {};
        (t in i || (i[t] = []), i[t].push(n), ue.set(e.element, i));
      }
      function le(e, t) {
        return (ue.get(e.element) || {})[t] || [];
      }
      function de(e, t, n) {
        var i = ue.get(e.element) || {};
        if (!i[t]) return !0;
        if (!n) return ((i[t] = []), ue.set(e.element, i), !0);
        var r = i[t].indexOf(n);
        return (
          -1 !== r && i[t].splice(r, 1),
          ue.set(e.element, i),
          i[t] && 0 === i[t].length
        );
      }
      function fe(e) {
        if ("string" == typeof e)
          try {
            e = JSON.parse(e);
          } catch (e) {
            return {};
          }
        return e;
      }
      function he(e, t, n) {
        if (e.element.contentWindow && e.element.contentWindow.postMessage) {
          var i = { method: t };
          void 0 !== n && (i.value = n);
          var r = parseFloat(
            navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"),
          );
          (r >= 8 && r < 10 && (i = JSON.stringify(i)),
            e.element.contentWindow.postMessage(i, e.origin));
        }
      }
      function pe(e, t) {
        var n,
          i = [];
        if ((t = fe(t)).event) {
          if ("error" === t.event)
            le(e, t.data.method).forEach(function (n) {
              var i = new Error(t.data.message);
              ((i.name = t.data.name), n.reject(i), de(e, t.data.method, n));
            });
          ((i = le(e, "event:".concat(t.event))), (n = t.data));
        } else if (t.method) {
          var r = (function (e, t) {
            var n = le(e, t);
            if (n.length < 1) return !1;
            var i = n.shift();
            return (de(e, t, i), i);
          })(e, t.method);
          r && (i.push(r), (n = t.value));
        }
        i.forEach(function (t) {
          try {
            if ("function" == typeof t) return void t.call(e, n);
            t.resolve(n);
          } catch (e) {}
        });
      }
      var ve = [
        "autopause",
        "autoplay",
        "background",
        "byline",
        "color",
        "controls",
        "dnt",
        "height",
        "id",
        "interactive_params",
        "keyboard",
        "loop",
        "maxheight",
        "maxwidth",
        "muted",
        "playsinline",
        "portrait",
        "responsive",
        "speed",
        "texttrack",
        "title",
        "transparent",
        "url",
        "width",
      ];
      function ye(e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return ve.reduce(function (t, n) {
          var i = e.getAttribute("data-vimeo-".concat(n));
          return ((i || "" === i) && (t[n] = "" === i ? 1 : i), t);
        }, t);
      }
      function me(e, t) {
        var n = e.html;
        if (!t) throw new TypeError("An element must be provided");
        if (null !== t.getAttribute("data-vimeo-initialized"))
          return t.querySelector("iframe");
        var i = document.createElement("div");
        return (
          (i.innerHTML = n),
          t.appendChild(i.firstChild),
          t.setAttribute("data-vimeo-initialized", "true"),
          t.querySelector("iframe")
        );
      }
      function ge(e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 ? arguments[2] : void 0;
        return new Promise(function (i, r) {
          if (!ee(e))
            throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
          var o = "https://vimeo.com/api/oembed.json?url=".concat(
            encodeURIComponent(e),
          );
          for (var a in t)
            t.hasOwnProperty(a) &&
              (o += "&".concat(a, "=").concat(encodeURIComponent(t[a])));
          var s =
            "XDomainRequest" in window
              ? new XDomainRequest()
              : new XMLHttpRequest();
          (s.open("GET", o, !0),
            (s.onload = function () {
              if (404 !== s.status)
                if (403 !== s.status)
                  try {
                    var t = JSON.parse(s.responseText);
                    if (403 === t.domain_status_code)
                      return (
                        me(t, n),
                        void r(new Error("“".concat(e, "” is not embeddable.")))
                      );
                    i(t);
                  } catch (e) {
                    r(e);
                  }
                else r(new Error("“".concat(e, "” is not embeddable.")));
              else r(new Error("“".concat(e, "” was not found.")));
            }),
            (s.onerror = function () {
              var e = s.status ? " (".concat(s.status, ")") : "";
              r(
                new Error(
                  "There was an error fetching the embed code from Vimeo".concat(
                    e,
                    ".",
                  ),
                ),
              );
            }),
            s.send());
        });
      }
      var be = new WeakMap(),
        we = new WeakMap(),
        Ee = {},
        ke = (function () {
          function e(t) {
            var n = this,
              i =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            if (
              ((function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e),
              window.jQuery &&
                t instanceof jQuery &&
                (t.length > 1 && window.console && console.warn, (t = t[0])),
              "undefined" != typeof document &&
                "string" == typeof t &&
                (t = document.getElementById(t)),
              !(function (e) {
                return Boolean(
                  e &&
                  1 === e.nodeType &&
                  "nodeName" in e &&
                  e.ownerDocument &&
                  e.ownerDocument.defaultView,
                );
              })(t))
            )
              throw new TypeError(
                "You must pass either a valid element or a valid id.",
              );
            if ("IFRAME" !== t.nodeName) {
              var r = t.querySelector("iframe");
              r && (t = r);
            }
            if ("IFRAME" === t.nodeName && !ee(t.getAttribute("src") || ""))
              throw new Error("The player element passed isn’t a Vimeo embed.");
            if (be.has(t)) return be.get(t);
            ((this._window = t.ownerDocument.defaultView),
              (this.element = t),
              (this.origin = "*"));
            var o = new se(function (e, r) {
              if (
                ((n._onMessage = function (t) {
                  if (ee(t.origin) && n.element.contentWindow === t.source) {
                    "*" === n.origin && (n.origin = t.origin);
                    var i = fe(t.data);
                    if (
                      i &&
                      "error" === i.event &&
                      i.data &&
                      "ready" === i.data.method
                    ) {
                      var o = new Error(i.data.message);
                      return ((o.name = i.data.name), void r(o));
                    }
                    var a = i && "ready" === i.event,
                      s = i && "ping" === i.method;
                    if (a || s)
                      return (
                        n.element.setAttribute("data-ready", "true"),
                        void e()
                      );
                    pe(n, i);
                  }
                }),
                n._window.addEventListener("message", n._onMessage),
                "IFRAME" !== n.element.nodeName)
              ) {
                var o = ye(t, i);
                ge(te(o), o, t)
                  .then(function (e) {
                    var i,
                      r,
                      o,
                      a = me(e, t);
                    return (
                      (n.element = a),
                      (n._originalElement = t),
                      (i = t),
                      (r = a),
                      (o = ue.get(i)),
                      ue.set(r, o),
                      ue.delete(i),
                      be.set(n.element, n),
                      e
                    );
                  })
                  .catch(r);
              }
            });
            if (
              (we.set(this, o),
              be.set(this.element, this),
              "IFRAME" === this.element.nodeName && he(this, "ping"),
              Ee.isEnabled)
            ) {
              var a = function () {
                return Ee.exit();
              };
              ((this.fullscreenchangeHandler = function () {
                (Ee.isFullscreen
                  ? ce(n, "event:exitFullscreen", a)
                  : de(n, "event:exitFullscreen", a),
                  n.ready().then(function () {
                    he(n, "fullscreenchange", Ee.isFullscreen);
                  }));
              }),
                Ee.on("fullscreenchange", this.fullscreenchangeHandler));
            }
            return this;
          }
          var t, n, i;
          return (
            (t = e),
            (n = [
              {
                key: "callMethod",
                value: function (e) {
                  var t = this,
                    n =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {};
                  return new se(function (i, r) {
                    return t
                      .ready()
                      .then(function () {
                        (ce(t, e, { resolve: i, reject: r }), he(t, e, n));
                      })
                      .catch(r);
                  });
                },
              },
              {
                key: "get",
                value: function (e) {
                  var t = this;
                  return new se(function (n, i) {
                    return (
                      (e = Z(e, "get")),
                      t
                        .ready()
                        .then(function () {
                          (ce(t, e, { resolve: n, reject: i }), he(t, e));
                        })
                        .catch(i)
                    );
                  });
                },
              },
              {
                key: "set",
                value: function (e, t) {
                  var n = this;
                  return new se(function (i, r) {
                    if (((e = Z(e, "set")), null == t))
                      throw new TypeError("There must be a value to set.");
                    return n
                      .ready()
                      .then(function () {
                        (ce(n, e, { resolve: i, reject: r }), he(n, e, t));
                      })
                      .catch(r);
                  });
                },
              },
              {
                key: "on",
                value: function (e, t) {
                  if (!e) throw new TypeError("You must pass an event name.");
                  if (!t)
                    throw new TypeError("You must pass a callback function.");
                  if ("function" != typeof t)
                    throw new TypeError("The callback must be a function.");
                  (0 === le(this, "event:".concat(e)).length &&
                    this.callMethod("addEventListener", e).catch(
                      function () {},
                    ),
                    ce(this, "event:".concat(e), t));
                },
              },
              {
                key: "off",
                value: function (e, t) {
                  if (!e) throw new TypeError("You must pass an event name.");
                  if (t && "function" != typeof t)
                    throw new TypeError("The callback must be a function.");
                  de(this, "event:".concat(e), t) &&
                    this.callMethod("removeEventListener", e).catch(
                      function (e) {},
                    );
                },
              },
              {
                key: "loadVideo",
                value: function (e) {
                  return this.callMethod("loadVideo", e);
                },
              },
              {
                key: "ready",
                value: function () {
                  var e =
                    we.get(this) ||
                    new se(function (e, t) {
                      t(new Error("Unknown player. Probably unloaded."));
                    });
                  return se.resolve(e);
                },
              },
              {
                key: "addCuePoint",
                value: function (e) {
                  var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                  return this.callMethod("addCuePoint", { time: e, data: t });
                },
              },
              {
                key: "removeCuePoint",
                value: function (e) {
                  return this.callMethod("removeCuePoint", e);
                },
              },
              {
                key: "enableTextTrack",
                value: function (e, t) {
                  if (!e) throw new TypeError("You must pass a language.");
                  return this.callMethod("enableTextTrack", {
                    language: e,
                    kind: t,
                  });
                },
              },
              {
                key: "disableTextTrack",
                value: function () {
                  return this.callMethod("disableTextTrack");
                },
              },
              {
                key: "pause",
                value: function () {
                  return this.callMethod("pause");
                },
              },
              {
                key: "play",
                value: function () {
                  return this.callMethod("play");
                },
              },
              {
                key: "requestFullscreen",
                value: function () {
                  return Ee.isEnabled
                    ? Ee.request(this.element)
                    : this.callMethod("requestFullscreen");
                },
              },
              {
                key: "exitFullscreen",
                value: function () {
                  return Ee.isEnabled
                    ? Ee.exit()
                    : this.callMethod("exitFullscreen");
                },
              },
              {
                key: "getFullscreen",
                value: function () {
                  return Ee.isEnabled
                    ? se.resolve(Ee.isFullscreen)
                    : this.get("fullscreen");
                },
              },
              {
                key: "requestPictureInPicture",
                value: function () {
                  return this.callMethod("requestPictureInPicture");
                },
              },
              {
                key: "exitPictureInPicture",
                value: function () {
                  return this.callMethod("exitPictureInPicture");
                },
              },
              {
                key: "getPictureInPicture",
                value: function () {
                  return this.get("pictureInPicture");
                },
              },
              {
                key: "unload",
                value: function () {
                  return this.callMethod("unload");
                },
              },
              {
                key: "destroy",
                value: function () {
                  var e = this;
                  return new se(function (t) {
                    if (
                      (we.delete(e),
                      be.delete(e.element),
                      e._originalElement &&
                        (be.delete(e._originalElement),
                        e._originalElement.removeAttribute(
                          "data-vimeo-initialized",
                        )),
                      e.element &&
                        "IFRAME" === e.element.nodeName &&
                        e.element.parentNode &&
                        (e.element.parentNode.parentNode &&
                        e._originalElement &&
                        e._originalElement !== e.element.parentNode
                          ? e.element.parentNode.parentNode.removeChild(
                              e.element.parentNode,
                            )
                          : e.element.parentNode.removeChild(e.element)),
                      e.element &&
                        "DIV" === e.element.nodeName &&
                        e.element.parentNode)
                    ) {
                      e.element.removeAttribute("data-vimeo-initialized");
                      var n = e.element.querySelector("iframe");
                      n &&
                        n.parentNode &&
                        (n.parentNode.parentNode &&
                        e._originalElement &&
                        e._originalElement !== n.parentNode
                          ? n.parentNode.parentNode.removeChild(n.parentNode)
                          : n.parentNode.removeChild(n));
                    }
                    (e._window.removeEventListener("message", e._onMessage),
                      Ee.isEnabled &&
                        Ee.off("fullscreenchange", e.fullscreenchangeHandler),
                      t());
                  });
                },
              },
              {
                key: "getAutopause",
                value: function () {
                  return this.get("autopause");
                },
              },
              {
                key: "setAutopause",
                value: function (e) {
                  return this.set("autopause", e);
                },
              },
              {
                key: "getBuffered",
                value: function () {
                  return this.get("buffered");
                },
              },
              {
                key: "getCameraProps",
                value: function () {
                  return this.get("cameraProps");
                },
              },
              {
                key: "setCameraProps",
                value: function (e) {
                  return this.set("cameraProps", e);
                },
              },
              {
                key: "getChapters",
                value: function () {
                  return this.get("chapters");
                },
              },
              {
                key: "getCurrentChapter",
                value: function () {
                  return this.get("currentChapter");
                },
              },
              {
                key: "getColor",
                value: function () {
                  return this.get("color");
                },
              },
              {
                key: "setColor",
                value: function (e) {
                  return this.set("color", e);
                },
              },
              {
                key: "getCuePoints",
                value: function () {
                  return this.get("cuePoints");
                },
              },
              {
                key: "getCurrentTime",
                value: function () {
                  return this.get("currentTime");
                },
              },
              {
                key: "setCurrentTime",
                value: function (e) {
                  return this.set("currentTime", e);
                },
              },
              {
                key: "getDuration",
                value: function () {
                  return this.get("duration");
                },
              },
              {
                key: "getEnded",
                value: function () {
                  return this.get("ended");
                },
              },
              {
                key: "getLoop",
                value: function () {
                  return this.get("loop");
                },
              },
              {
                key: "setLoop",
                value: function (e) {
                  return this.set("loop", e);
                },
              },
              {
                key: "setMuted",
                value: function (e) {
                  return this.set("muted", e);
                },
              },
              {
                key: "getMuted",
                value: function () {
                  return this.get("muted");
                },
              },
              {
                key: "getPaused",
                value: function () {
                  return this.get("paused");
                },
              },
              {
                key: "getPlaybackRate",
                value: function () {
                  return this.get("playbackRate");
                },
              },
              {
                key: "setPlaybackRate",
                value: function (e) {
                  return this.set("playbackRate", e);
                },
              },
              {
                key: "getPlayed",
                value: function () {
                  return this.get("played");
                },
              },
              {
                key: "getQualities",
                value: function () {
                  return this.get("qualities");
                },
              },
              {
                key: "getQuality",
                value: function () {
                  return this.get("quality");
                },
              },
              {
                key: "setQuality",
                value: function (e) {
                  return this.set("quality", e);
                },
              },
              {
                key: "getSeekable",
                value: function () {
                  return this.get("seekable");
                },
              },
              {
                key: "getSeeking",
                value: function () {
                  return this.get("seeking");
                },
              },
              {
                key: "getTextTracks",
                value: function () {
                  return this.get("textTracks");
                },
              },
              {
                key: "getVideoEmbedCode",
                value: function () {
                  return this.get("videoEmbedCode");
                },
              },
              {
                key: "getVideoId",
                value: function () {
                  return this.get("videoId");
                },
              },
              {
                key: "getVideoTitle",
                value: function () {
                  return this.get("videoTitle");
                },
              },
              {
                key: "getVideoWidth",
                value: function () {
                  return this.get("videoWidth");
                },
              },
              {
                key: "getVideoHeight",
                value: function () {
                  return this.get("videoHeight");
                },
              },
              {
                key: "getVideoUrl",
                value: function () {
                  return this.get("videoUrl");
                },
              },
              {
                key: "getVolume",
                value: function () {
                  return this.get("volume");
                },
              },
              {
                key: "setVolume",
                value: function (e) {
                  return this.set("volume", e);
                },
              },
            ]),
            n && Q(t.prototype, n),
            i && Q(t, i),
            e
          );
        })();
      K ||
        ((Ee = (function () {
          var e = (function () {
              for (
                var e,
                  t = [
                    [
                      "requestFullscreen",
                      "exitFullscreen",
                      "fullscreenElement",
                      "fullscreenEnabled",
                      "fullscreenchange",
                      "fullscreenerror",
                    ],
                    [
                      "webkitRequestFullscreen",
                      "webkitExitFullscreen",
                      "webkitFullscreenElement",
                      "webkitFullscreenEnabled",
                      "webkitfullscreenchange",
                      "webkitfullscreenerror",
                    ],
                    [
                      "webkitRequestFullScreen",
                      "webkitCancelFullScreen",
                      "webkitCurrentFullScreenElement",
                      "webkitCancelFullScreen",
                      "webkitfullscreenchange",
                      "webkitfullscreenerror",
                    ],
                    [
                      "mozRequestFullScreen",
                      "mozCancelFullScreen",
                      "mozFullScreenElement",
                      "mozFullScreenEnabled",
                      "mozfullscreenchange",
                      "mozfullscreenerror",
                    ],
                    [
                      "msRequestFullscreen",
                      "msExitFullscreen",
                      "msFullscreenElement",
                      "msFullscreenEnabled",
                      "MSFullscreenChange",
                      "MSFullscreenError",
                    ],
                  ],
                  n = 0,
                  i = t.length,
                  r = {};
                n < i;
                n++
              )
                if ((e = t[n]) && e[1] in document) {
                  for (n = 0; n < e.length; n++) r[t[0][n]] = e[n];
                  return r;
                }
              return !1;
            })(),
            t = {
              fullscreenchange: e.fullscreenchange,
              fullscreenerror: e.fullscreenerror,
            },
            n = {
              request: function (t) {
                return new Promise(function (i, r) {
                  var o = function e() {
                    (n.off("fullscreenchange", e), i());
                  };
                  n.on("fullscreenchange", o);
                  var a = (t = t || document.documentElement)[
                    e.requestFullscreen
                  ]();
                  a instanceof Promise && a.then(o).catch(r);
                });
              },
              exit: function () {
                return new Promise(function (t, i) {
                  if (n.isFullscreen) {
                    var r = function e() {
                      (n.off("fullscreenchange", e), t());
                    };
                    n.on("fullscreenchange", r);
                    var o = document[e.exitFullscreen]();
                    o instanceof Promise && o.then(r).catch(i);
                  } else t();
                });
              },
              on: function (e, n) {
                var i = t[e];
                i && document.addEventListener(i, n);
              },
              off: function (e, n) {
                var i = t[e];
                i && document.removeEventListener(i, n);
              },
            };
          return (
            Object.defineProperties(n, {
              isFullscreen: {
                get: function () {
                  return Boolean(document[e.fullscreenElement]);
                },
              },
              element: {
                enumerable: !0,
                get: function () {
                  return document[e.fullscreenElement];
                },
              },
              isEnabled: {
                enumerable: !0,
                get: function () {
                  return Boolean(document[e.fullscreenEnabled]);
                },
              },
            }),
            n
          );
        })()),
        (function () {
          var e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : document,
            t = [].slice.call(
              e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]"),
            ),
            n = function (e) {
              "console" in window && console.error;
            };
          t.forEach(function (e) {
            try {
              if (null !== e.getAttribute("data-vimeo-defer")) return;
              var t = ye(e);
              ge(te(t), t, e)
                .then(function (t) {
                  return me(t, e);
                })
                .catch(n);
            } catch (e) {
              n();
            }
          });
        })(),
        (function () {
          var e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : document;
          window.VimeoPlayerResizeEmbeds_ ||
            ((window.VimeoPlayerResizeEmbeds_ = !0),
            window.addEventListener("message", function (t) {
              if (ee(t.origin) && t.data && "spacechange" === t.data.event)
                for (
                  var n = e.querySelectorAll("iframe"), i = 0;
                  i < n.length;
                  i++
                )
                  if (n[i].contentWindow === t.source) {
                    n[i].parentElement.style.paddingBottom = "".concat(
                      t.data.data[0].bottom,
                      "px",
                    );
                    break;
                  }
            }));
        })(),
        (function () {
          var e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : document;
          window.VimeoSeoMetadataAppended ||
            ((window.VimeoSeoMetadataAppended = !0),
            window.addEventListener("message", function (t) {
              if (ee(t.origin)) {
                var n = fe(t.data);
                if (n && "ready" === n.event)
                  for (
                    var i, r = e.querySelectorAll("iframe"), o = 0;
                    o < r.length;
                    o++
                  ) {
                    var a = r[o],
                      s = a.contentWindow === t.source;
                    ((i = a.src),
                      /^https:\/\/player\.vimeo\.com\/video\/\d+/.test(i) &&
                        s &&
                        new ke(a).callMethod(
                          "appendVideoMetadata",
                          window.location.href,
                        ));
                  }
              }
            }));
        })());
      const Pe = "//www.youtube.com/player_api";
      class Se {
        load(e) {
          if (window.YT && E(window.YT.Player)) return e();
          (this.attachCallback(e),
            this.shouldLoad() &&
              O("script", { src: `${location.protocol}${Pe}` }, document.head));
        }
        shouldLoad() {
          return !((e = document),
          (t = "script"),
          t ? y(e.querySelectorAll(t)) : []).some(
            (e) => e.src.replace(/^https?:/, "") === Pe,
          );
          var e, t;
        }
        attachCallback(e) {
          let t;
          (P(window.onYouTubeIframeAPIReady) ||
            (t = window.onYouTubeIframeAPIReady),
            (window.onYouTubeIframeAPIReady = () => {
              (t && t(), e());
            }));
        }
      }
      const _e = "Play Video";
      class Ce {
        constructor(e, t) {
          ((this.event = h()),
            (this.Splide = e),
            (this.slide = t),
            (this.container = T(this.slide, `.${v}`)),
            (this.parent = this.container || this.slide),
            this.init(),
            this.create(),
            this.show(),
            this.listen());
        }
        init() {
          (x(this.slide, `${p}${U}`), x(this.container, `${v}${U}`));
        }
        create() {
          ((this.video = O("div", $, this.parent)),
            (this.playButton = O(
              "button",
              {
                class: H,
                type: "button",
                "aria-label": this.Splide.options.i18n.playVideo || _e,
              },
              this.video,
            )),
            (this.wrapper = O("div", Y, this.video)),
            (this.placeholder = O("div", null, this.wrapper)));
        }
        listen() {
          this.parent.addEventListener("click", () => {
            this.event.emit("click");
          });
        }
        toggleButton(e) {
          j(this.playButton, e ? "" : "none");
        }
        toggleWrapper(e) {
          j(this.wrapper, e ? "" : "none");
        }
        getPlaceholder() {
          return this.placeholder;
        }
        hide() {
          (this.toggleButton(!1), this.toggleWrapper(!0));
        }
        show() {
          (this.disabled || this.toggleButton(!0), this.toggleWrapper(!1));
        }
        disable(e) {
          ((this.disabled = e), e && this.toggleButton(!1));
        }
        on(e, t) {
          this.event.on(e, t);
        }
        destroy() {
          (R(this.slide, `${p}${U}`),
            R(this.container, `${v}${U}`),
            _(this.video, (e) => {
              e && e.parentNode && e.parentNode.removeChild(e);
            }),
            this.event.destroy());
        }
      }
      const xe = [
        [
          "data-splide-youtube",
          class extends J {
            constructor(e, t, n = {}) {
              (super(e, t, n),
                (this.videoId = this.parseVideoId(t)),
                this.videoId &&
                  (this.state.set(2),
                  new Se().load(this.onAPIReady.bind(this))));
            }
            onAPIReady() {
              const { state: e } = this,
                t = e.is(4);
              (e.set(3), t && this.play());
            }
            createPlayer(e) {
              const {
                options: t,
                options: { playerOptions: n = {} },
              } = this;
              return new YT.Player(this.target, {
                videoId: e,
                host: t.host,
                playerVars: N(
                  {
                    controls: t.hideControls ? 0 : 1,
                    iv_load_policy: 3,
                    loop: t.loop ? 1 : 0,
                    playlist: t.loop ? e : void 0,
                    rel: 0,
                    autoplay: 0,
                    mute: t.mute ? 1 : 0,
                  },
                  n.youtube || {},
                ),
                events: {
                  onReady: this.onPlayerReady.bind(this),
                  onStateChange: this.onPlayerStateChange.bind(this),
                  onError: this.onError.bind(this),
                },
              });
            }
            onPlayerReady() {
              (super.onPlayerReady(),
                this.player.setVolume(100 * B(this.options.volume, 0, 1)));
            }
            onPlayerStateChange(e) {
              const { PLAYING: t, PAUSED: n, ENDED: i } = YT.PlayerState;
              switch (!0) {
                case e.data === t:
                  this.onPlay();
                  break;
                case e.data === n:
                  this.onPause();
                  break;
                case e.data === i:
                  this.onEnded();
              }
            }
            playVideo() {
              this.player.playVideo();
            }
            pauseVideo() {
              this.player.pauseVideo();
            }
            parseVideoId(e) {
              return 0 === e.indexOf("http") ? this.parseUrl(e) : e;
            }
            parseUrl(e) {
              const [, t] = e.split(/[#?]/),
                n =
                  ((i = t.split("&")),
                  (r = (e) => 0 === e.indexOf("v=")),
                  y(i).filter(r)[0]);
              var i, r;
              return n && n.replace("v=", "");
            }
          },
        ],
        [
          "data-splide-vimeo",
          class extends J {
            constructor(e, t, n = {}) {
              (super(e, t, n), this.state.set(3));
            }
            createPlayer(e) {
              const {
                  options: t,
                  options: { playerOptions: n = {} },
                } = this,
                i = 0 === e.indexOf("http") ? { url: e } : { id: +e },
                r = new ke(
                  this.target,
                  N(
                    i,
                    { controls: !t.hideControls, loop: t.loop, muted: t.mute },
                    n.vimeo || {},
                  ),
                );
              return (
                r.on("play", this.onPlay),
                r.on("pause", this.onPause),
                r.on("ended", this.onEnded),
                r.ready().then(this.onPlayerReady, this.onError),
                r.getMuted() || r.setVolume(B(t.volume, 0, 1)),
                r
              );
            }
            playVideo() {
              this.player.play().catch(() => {
                this.state.is(7) && this.state.set(5);
              });
            }
            pauseVideo() {
              this.player.pause();
            }
          },
        ],
        [
          "data-splide-html-video",
          class extends J {
            constructor(e, t, n = {}) {
              (super(e, t, n), this.state.set(3));
            }
            createPlayer(e) {
              const {
                  options: t,
                  options: { playerOptions: n = {} },
                } = this,
                i = O("video", { src: e }, this.target),
                r = i.addEventListener.bind(i);
              return (
                N(
                  i,
                  {
                    controls: !t.hideControls,
                    loop: t.loop,
                    volume: B(t.volume, 0, 1),
                    muted: t.mute,
                  },
                  n.htmlVideo || {},
                ),
                r("play", this.onPlay),
                r("pause", this.onPause),
                r("ended", this.onEnded),
                r("loadeddata", this.onPlayerReady),
                r("error", this.onError),
                i
              );
            }
            playVideo() {
              const e = this.player.play();
              e && e.catch(this.onError.bind(this));
            }
            pauseVideo() {
              this.player.pause();
            }
            onError() {
              this.state.is(7) ? this.state.set(5) : super.onError();
            }
            destroy() {
              super.destroy();
              const { player: e } = this,
                t = e.addEventListener.bind(e);
              (t("play", this.onPlay),
                t("pause", this.onPause),
                t("ended", this.onEnded),
                t("loadeddata", this.onPlayerReady));
            }
          },
        ],
      ];
      class Ae {
        constructor(e, t) {
          ((this.Splide = e),
            (this.slide = t),
            (this.event = h(e)),
            (this.options = F(F({}, X), this.Splide.options.video)),
            this.createPlayer(t),
            this.player && this.listen());
        }
        createPlayer(e) {
          xe.forEach(([t, n]) => {
            const i = (function (e, t) {
              return e.getAttribute(t);
            })(e, t);
            i &&
              ((this.ui = new Ce(this.Splide, e)),
              (this.player = new n(this.ui.getPlaceholder(), i, this.options)),
              this.ui.disable(this.options.disableOverlayUI));
          });
        }
        listen() {
          const { player: e, event: t } = this;
          (this.ui.on("click", this.onClick.bind(this)),
            e.on("play", this.onPlay.bind(this)),
            e.on("played", this.onPlayed.bind(this)),
            e.on("pause", this.onPause.bind(this)),
            e.on("paused", this.onPaused.bind(this)),
            e.on("ended", this.onEnded.bind(this)),
            e.on("error", this.onError.bind(this)),
            t.on(["move", "scroll"], this.pause.bind(this)),
            t.on(G, this.onVideoClick.bind(this)),
            t.on("drag", () => {
              (t.off(d),
                t.on(d, () => {
                  (this.pause(), t.off(d));
                }));
            }),
            this.options.autoplay &&
              t.on(
                ["mounted", "moved", "scrolled"],
                this.onAutoplayRequested.bind(this),
              ));
        }
        onClick() {
          (this.isPaused() ? this.play() : this.pause(),
            this.event.emit(G, this));
        }
        onVideoClick(e) {
          this !== e && this.pause();
        }
        onPlay() {
          this.ui.hide();
        }
        onPlayed() {
          (this.ui.hide(),
            this.togglePlaying(!0),
            this.event.emit("video:play", this));
        }
        onPause() {
          this.ui.show();
        }
        onPaused() {
          (this.togglePlaying(!1), this.event.emit("video:pause", this));
        }
        onEnded() {
          (this.togglePlaying(!1), this.event.emit("video:ended", this));
        }
        onError() {
          (x(this.slide, "is-error"),
            this.ui.show(),
            this.event.emit("video:error", this));
        }
        onAutoplayRequested() {
          this.Splide.Components.Slides.getAt(this.Splide.index).slide ===
            this.slide && this.play();
        }
        togglePlaying(e) {
          C(this.Splide.root, "is-playing", e);
        }
        play() {
          this.player && !this.disabled && this.player.play();
        }
        pause() {
          this.player && !this.disabled && this.player.pause();
        }
        destroy() {
          (this.player && (this.ui.destroy(), this.player.destroy()),
            this.disable(!1));
        }
        disable(e) {
          ((this.disabled = e), C(this.Splide.root, "is-video-disabled", e));
        }
        isPaused() {
          return this.player.isPaused();
        }
      }
      function Te(e, t) {
        const { on: n } = h(e),
          { Slides: i } = t,
          r = {};
        function o() {
          (i.forEach((t) => {
            const { slide: n } = t;
            var i, o;
            ((o = `${p}${U}`),
              ((i = n) && i.classList.contains(o)) ||
                (r[t.index] = new Ae(e, n)));
          }),
            i.update());
        }
        return {
          mount: function () {
            (o(), n("refresh", o));
          },
          destroy: function () {
            M(r, (e) => {
              e.destroy();
            });
          },
          play: function (t = e.index) {
            const n = r[t];
            n && n.play();
          },
          pause: function () {
            M(r, (e) => {
              e.pause();
            });
          },
          disable: function (e) {
            M(r, (t) => {
              t.disable(e);
            });
          },
        };
      }
    },
    846: (e, t, n) => {
      function i(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          ((i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i));
        }
      }
      n.d(t, { eB: () => cn });
      var r = "(prefers-reduced-motion: reduce)",
        o = 4,
        a = 5,
        s = {
          CREATED: 1,
          MOUNTED: 2,
          IDLE: 3,
          MOVING: o,
          SCROLLING: a,
          DRAGGING: 6,
          DESTROYED: 7,
        };
      function u(e) {
        e.length = 0;
      }
      function c(e, t, n) {
        return Array.prototype.slice.call(e, t, n);
      }
      function l(e) {
        return e.bind.apply(e, [null].concat(c(arguments, 1)));
      }
      var d = setTimeout,
        f = function () {};
      function h(e) {
        return requestAnimationFrame(e);
      }
      function p(e, t) {
        return typeof t === e;
      }
      function v(e) {
        return !w(e) && p("object", e);
      }
      var y = Array.isArray,
        m = l(p, "function"),
        g = l(p, "string"),
        b = l(p, "undefined");
      function w(e) {
        return null === e;
      }
      function E(e) {
        try {
          return (
            e instanceof (e.ownerDocument.defaultView || window).HTMLElement
          );
        } catch (e) {
          return !1;
        }
      }
      function k(e) {
        return y(e) ? e : [e];
      }
      function P(e, t) {
        k(e).forEach(t);
      }
      function S(e, t) {
        return e.indexOf(t) > -1;
      }
      function _(e, t) {
        return (e.push.apply(e, k(t)), e);
      }
      function C(e, t, n) {
        e &&
          P(t, function (t) {
            t && e.classList[n ? "add" : "remove"](t);
          });
      }
      function x(e, t) {
        C(e, g(t) ? t.split(" ") : t, !0);
      }
      function A(e, t) {
        P(t, e.appendChild.bind(e));
      }
      function T(e, t) {
        P(e, function (e) {
          var n = (t || e).parentNode;
          n && n.insertBefore(e, t);
        });
      }
      function L(e, t) {
        return E(e) && (e.msMatchesSelector || e.matches).call(e, t);
      }
      function M(e, t) {
        var n = e ? c(e.children) : [];
        return t
          ? n.filter(function (e) {
              return L(e, t);
            })
          : n;
      }
      function N(e, t) {
        return t ? M(e, t)[0] : e.firstElementChild;
      }
      var F = Object.keys;
      function I(e, t, n) {
        return (
          e &&
            (n ? F(e).reverse() : F(e)).forEach(function (n) {
              "__proto__" !== n && t(e[n], n);
            }),
          e
        );
      }
      function O(e) {
        return (
          c(arguments, 1).forEach(function (t) {
            I(t, function (n, i) {
              e[i] = t[i];
            });
          }),
          e
        );
      }
      function j(e) {
        return (
          c(arguments, 1).forEach(function (t) {
            I(t, function (t, n) {
              y(t)
                ? (e[n] = t.slice())
                : v(t)
                  ? (e[n] = j({}, v(e[n]) ? e[n] : {}, t))
                  : (e[n] = t);
            });
          }),
          e
        );
      }
      function R(e, t) {
        P(t || F(e), function (t) {
          delete e[t];
        });
      }
      function V(e, t) {
        P(e, function (e) {
          P(t, function (t) {
            e && e.removeAttribute(t);
          });
        });
      }
      function D(e, t, n) {
        v(t)
          ? I(t, function (t, n) {
              D(e, n, t);
            })
          : P(e, function (e) {
              w(n) || "" === n ? V(e, t) : e.setAttribute(t, String(n));
            });
      }
      function z(e, t, n) {
        var i = document.createElement(e);
        return (t && (g(t) ? x(i, t) : D(i, t)), n && A(n, i), i);
      }
      function q(e, t, n) {
        if (b(n)) return getComputedStyle(e)[t];
        w(n) || (e.style[t] = "" + n);
      }
      function W(e, t) {
        q(e, "display", t);
      }
      function B(e) {
        (e.setActive && e.setActive()) || e.focus({ preventScroll: !0 });
      }
      function $(e, t) {
        return e.getAttribute(t);
      }
      function Y(e, t) {
        return e && e.classList.contains(t);
      }
      function H(e) {
        return e.getBoundingClientRect();
      }
      function U(e) {
        P(e, function (e) {
          e && e.parentNode && e.parentNode.removeChild(e);
        });
      }
      function X(e) {
        return N(new DOMParser().parseFromString(e, "text/html").body);
      }
      function G(e, t) {
        (e.preventDefault(),
          t && (e.stopPropagation(), e.stopImmediatePropagation()));
      }
      function J(e, t) {
        return e && e.querySelector(t);
      }
      function Q(e, t) {
        return t ? c(e.querySelectorAll(t)) : [];
      }
      function K(e, t) {
        C(e, t, !1);
      }
      function Z(e) {
        return e.timeStamp;
      }
      function ee(e) {
        return g(e) ? e : e ? e + "px" : "";
      }
      var te = "splide",
        ne = "data-" + te;
      function ie(e, t) {
        if (!e) throw new Error("[" + te + "] " + (t || ""));
      }
      var re = Math.min,
        oe = Math.max,
        ae = Math.floor,
        se = Math.ceil,
        ue = Math.abs;
      function ce(e, t, n) {
        return ue(e - t) < n;
      }
      function le(e, t, n, i) {
        var r = re(t, n),
          o = oe(t, n);
        return i ? r < e && e < o : r <= e && e <= o;
      }
      function de(e, t, n) {
        var i = re(t, n),
          r = oe(t, n);
        return re(oe(i, e), r);
      }
      function fe(e) {
        return +(e > 0) - +(e < 0);
      }
      function he(e, t) {
        return (
          P(t, function (t) {
            e = e.replace("%s", "" + t);
          }),
          e
        );
      }
      function pe(e) {
        return e < 10 ? "0" + e : "" + e;
      }
      var ve = {};
      function ye(e) {
        return "" + e + pe((ve[e] = (ve[e] || 0) + 1));
      }
      function me() {
        var e = [];
        function t(e, t, n) {
          P(e, function (e) {
            e &&
              P(t, function (t) {
                t.split(" ").forEach(function (t) {
                  var i = t.split(".");
                  n(e, i[0], i[1]);
                });
              });
          });
        }
        return {
          bind: function (n, i, r, o) {
            t(n, i, function (t, n, i) {
              var a = "addEventListener" in t,
                s = a
                  ? t.removeEventListener.bind(t, n, r, o)
                  : t.removeListener.bind(t, r);
              (a ? t.addEventListener(n, r, o) : t.addListener(r),
                e.push([t, n, i, r, s]));
            });
          },
          unbind: function (n, i, r) {
            t(n, i, function (t, n, i) {
              e = e.filter(function (e) {
                return (
                  !!(
                    e[0] !== t ||
                    e[1] !== n ||
                    e[2] !== i ||
                    (r && e[3] !== r)
                  ) || (e[4](), !1)
                );
              });
            });
          },
          dispatch: function (e, t, n) {
            var i,
              r = !0;
            return (
              "function" == typeof CustomEvent
                ? (i = new CustomEvent(t, { bubbles: r, detail: n }))
                : (i = document.createEvent("CustomEvent")).initCustomEvent(
                    t,
                    r,
                    !1,
                    n,
                  ),
              e.dispatchEvent(i),
              i
            );
          },
          destroy: function () {
            (e.forEach(function (e) {
              e[4]();
            }),
              u(e));
          },
        };
      }
      var ge = "mounted",
        be = "ready",
        we = "move",
        Ee = "moved",
        ke = "click",
        Pe = "active",
        Se = "inactive",
        _e = "visible",
        Ce = "hidden",
        xe = "refresh",
        Ae = "updated",
        Te = "resize",
        Le = "resized",
        Me = "scroll",
        Ne = "scrolled",
        Fe = "destroy",
        Ie = "arrows:mounted",
        Oe = "navigation:mounted",
        je = "autoplay:play",
        Re = "autoplay:pause",
        Ve = "lazyload:loaded",
        De = "sk",
        ze = "sh",
        qe = "ei";
      function We(e) {
        var t = e ? e.event.bus : document.createDocumentFragment(),
          n = me();
        return (
          e && e.event.on(Fe, n.destroy),
          O(n, {
            bus: t,
            on: function (e, i) {
              n.bind(t, k(e).join(" "), function (e) {
                i.apply(i, y(e.detail) ? e.detail : []);
              });
            },
            off: l(n.unbind, t),
            emit: function (e) {
              n.dispatch(t, e, c(arguments, 1));
            },
          })
        );
      }
      function Be(e, t, n, i) {
        var r,
          o,
          a = Date.now,
          s = 0,
          u = !0,
          c = 0;
        function l() {
          if (!u) {
            if (
              ((s = e ? re((a() - r) / e, 1) : 1),
              n && n(s),
              s >= 1 && (t(), (r = a()), i && ++c >= i))
            )
              return d();
            o = h(l);
          }
        }
        function d() {
          u = !0;
        }
        function f() {
          (o && cancelAnimationFrame(o), (s = 0), (o = 0), (u = !0));
        }
        return {
          start: function (t) {
            (t || f(), (r = a() - (t ? s * e : 0)), (u = !1), (o = h(l)));
          },
          rewind: function () {
            ((r = a()), (s = 0), n && n(s));
          },
          pause: d,
          cancel: f,
          set: function (t) {
            e = t;
          },
          isPaused: function () {
            return u;
          },
        };
      }
      var $e = "Arrow",
        Ye = $e + "Left",
        He = $e + "Right",
        Ue = $e + "Up",
        Xe = $e + "Down",
        Ge = "ttb",
        Je = {
          width: ["height"],
          left: ["top", "right"],
          right: ["bottom", "left"],
          x: ["y"],
          X: ["Y"],
          Y: ["X"],
          ArrowLeft: [Ue, He],
          ArrowRight: [Xe, Ye],
        };
      function Qe(e, t, n) {
        return {
          resolve: function (e, t, i) {
            var r =
              "rtl" !== (i = i || n.direction) || t ? (i === Ge ? 0 : -1) : 1;
            return (
              (Je[e] && Je[e][r]) ||
              e.replace(/width|left|right/i, function (e, t) {
                var n = Je[e.toLowerCase()][r] || e;
                return t > 0 ? n.charAt(0).toUpperCase() + n.slice(1) : n;
              })
            );
          },
          orient: function (e) {
            return e * ("rtl" === n.direction ? 1 : -1);
          },
        };
      }
      var Ke = "role",
        Ze = "tabindex",
        et = "aria-",
        tt = et + "controls",
        nt = et + "current",
        it = et + "selected",
        rt = et + "label",
        ot = et + "labelledby",
        at = et + "hidden",
        st = et + "orientation",
        ut = et + "roledescription",
        ct = et + "live",
        lt = et + "busy",
        dt = et + "atomic",
        ft = [Ke, Ze, "disabled", tt, nt, rt, ot, at, st, ut],
        ht = te + "__",
        pt = "is-",
        vt = te,
        yt = ht + "track",
        mt = ht + "list",
        gt = ht + "slide",
        bt = gt + "--clone",
        wt = gt + "__container",
        Et = ht + "arrows",
        kt = ht + "arrow",
        Pt = kt + "--prev",
        St = kt + "--next",
        _t = ht + "pagination",
        Ct = _t + "__page",
        xt = ht + "progress" + "__bar",
        At = ht + "toggle",
        Tt = ht + "sr",
        Lt = pt + "initialized",
        Mt = pt + "active",
        Nt = pt + "prev",
        Ft = pt + "next",
        It = pt + "visible",
        Ot = pt + "loading",
        jt = pt + "focus-in",
        Rt = pt + "overflow",
        Vt = [Mt, It, Nt, Ft, Ot, jt, Rt],
        Dt = {
          slide: gt,
          clone: bt,
          arrows: Et,
          arrow: kt,
          prev: Pt,
          next: St,
          pagination: _t,
          page: Ct,
          spinner: ht + "spinner",
        };
      var zt = "touchstart mousedown",
        qt = "touchmove mousemove",
        Wt = "touchend touchcancel mouseup click";
      var Bt = "slide",
        $t = "loop",
        Yt = "fade";
      function Ht(e, t, n, i) {
        var r,
          s = We(e),
          u = s.on,
          c = s.emit,
          d = s.bind,
          f = e.Components,
          h = e.root,
          p = e.options,
          v = p.isNavigation,
          y = p.updateOnMove,
          m = p.i18n,
          g = p.pagination,
          b = p.slideFocus,
          w = f.Direction.resolve,
          E = $(i, "style"),
          k = $(i, rt),
          P = n > -1,
          S = N(i, "." + wt);
        function _() {
          var r = e.splides
            .map(function (e) {
              var n = e.splide.Components.Slides.getAt(t);
              return n ? n.slide.id : "";
            })
            .join(" ");
          (D(i, rt, he(m.slideX, (P ? n : t) + 1)),
            D(i, tt, r),
            D(i, Ke, b ? "button" : ""),
            b && V(i, ut));
        }
        function x() {
          r || A();
        }
        function A() {
          if (!r) {
            var n = e.index;
            ((s = T()) !== Y(i, Mt) &&
              (C(i, Mt, s), D(i, nt, (v && s) || ""), c(s ? Pe : Se, L)),
              (function () {
                var t = (function () {
                    if (e.is(Yt)) return T();
                    var t = H(f.Elements.track),
                      n = H(i),
                      r = w("left", !0),
                      o = w("right", !0);
                    return ae(t[r]) <= se(n[r]) && ae(n[o]) <= se(t[o]);
                  })(),
                  n = !t && (!T() || P);
                e.state.is([o, a]) || D(i, at, n || "");
                (D(Q(i, p.focusableNodes || ""), Ze, n ? -1 : ""),
                  b && D(i, Ze, n ? -1 : 0));
                t !== Y(i, It) && (C(i, It, t), c(t ? _e : Ce, L));
                if (!t && document.activeElement === i) {
                  var r = f.Slides.getAt(e.index);
                  r && B(r.slide);
                }
              })(),
              C(i, Nt, t === n - 1),
              C(i, Ft, t === n + 1));
          }
          var s;
        }
        function T() {
          var i = e.index;
          return i === t || (p.cloneStatus && i === n);
        }
        var L = {
          index: t,
          slideIndex: n,
          slide: i,
          container: S,
          isClone: P,
          mount: function () {
            (P ||
              ((i.id = h.id + "-slide" + pe(t + 1)),
              D(i, Ke, g ? "tabpanel" : "group"),
              D(i, ut, m.slide),
              D(i, rt, k || he(m.slideLabel, [t + 1, e.length]))),
              d(i, "click", l(c, ke, L)),
              d(i, "keydown", l(c, De, L)),
              u([Ee, ze, Ne], A),
              u(Oe, _),
              y && u(we, x));
          },
          destroy: function () {
            ((r = !0),
              s.destroy(),
              K(i, Vt),
              V(i, ft),
              D(i, "style", E),
              D(i, rt, k || ""));
          },
          update: A,
          style: function (e, t, n) {
            q((n && S) || i, e, t);
          },
          isWithin: function (n, i) {
            var r = ue(n - t);
            return (
              P || (!p.rewind && !e.is($t)) || (r = re(r, e.length - r)),
              r <= i
            );
          },
        };
        return L;
      }
      var Ut = "http://www.w3.org/2000/svg",
        Xt =
          "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
      var Gt = ne + "-interval";
      var Jt = { passive: !1, capture: !0 };
      var Qt = { Spacebar: " ", Right: He, Left: Ye, Up: Ue, Down: Xe };
      function Kt(e) {
        return ((e = g(e) ? e : e.key), Qt[e] || e);
      }
      var Zt = "keydown";
      var en = ne + "-lazy",
        tn = en + "-srcset",
        nn = "[" + en + "], [" + tn + "]";
      var rn = [" ", "Enter"];
      var on = Object.freeze({
          __proto__: null,
          Media: function (e, t, n) {
            var i = e.state,
              o = n.breakpoints || {},
              a = n.reducedMotion || {},
              s = me(),
              u = [];
            function c(e) {
              e && s.destroy();
            }
            function l(e, t) {
              var n = matchMedia(t);
              (s.bind(n, "change", d), u.push([e, n]));
            }
            function d() {
              var t = i.is(7),
                r = n.direction,
                o = u.reduce(function (e, t) {
                  return j(e, t[1].matches ? t[0] : {});
                }, {});
              (R(n),
                f(o),
                n.destroy
                  ? e.destroy("completely" === n.destroy)
                  : t
                    ? (c(!0), e.mount())
                    : r !== n.direction && e.refresh());
            }
            function f(t, r, o) {
              (j(n, t),
                r && j(Object.getPrototypeOf(n), t),
                (!o && i.is(1)) || e.emit(Ae, n));
            }
            return {
              setup: function () {
                var e = "min" === n.mediaQuery;
                (F(o)
                  .sort(function (t, n) {
                    return e ? +t - +n : +n - +t;
                  })
                  .forEach(function (t) {
                    l(o[t], "(" + (e ? "min" : "max") + "-width:" + t + "px)");
                  }),
                  l(a, r),
                  d());
              },
              destroy: c,
              reduce: function (e) {
                matchMedia(r).matches && (e ? j(n, a) : R(n, F(a)));
              },
              set: f,
            };
          },
          Direction: Qe,
          Elements: function (e, t, n) {
            var i,
              r,
              o,
              a = We(e),
              s = a.on,
              c = a.bind,
              l = e.root,
              d = n.i18n,
              f = {},
              h = [],
              p = [],
              v = [];
            function y() {
              ((i = w("." + yt)),
                (r = N(i, "." + mt)),
                ie(i && r, "A track/list element is missing."),
                _(h, M(r, "." + gt + ":not(." + bt + ")")),
                I(
                  {
                    arrows: Et,
                    pagination: _t,
                    prev: Pt,
                    next: St,
                    bar: xt,
                    toggle: At,
                  },
                  function (e, t) {
                    f[t] = w("." + e);
                  },
                ),
                O(f, { root: l, track: i, list: r, slides: h }),
                (function () {
                  var e = l.id || ye(te),
                    t = n.role;
                  ((l.id = e),
                    (i.id = i.id || e + "-track"),
                    (r.id = r.id || e + "-list"),
                    !$(l, Ke) && "SECTION" !== l.tagName && t && D(l, Ke, t));
                  (D(l, ut, d.carousel), D(r, Ke, "presentation"));
                })(),
                b());
            }
            function g(e) {
              var t = ft.concat("style");
              (u(h),
                K(l, p),
                K(i, v),
                V([i, r], t),
                V(l, e ? t : ["style", ut]));
            }
            function b() {
              (K(l, p),
                K(i, v),
                (p = E(vt)),
                (v = E(yt)),
                x(l, p),
                x(i, v),
                D(l, rt, n.label),
                D(l, ot, n.labelledby));
            }
            function w(e) {
              var t = J(l, e);
              return t &&
                (function (e, t) {
                  if (m(e.closest)) return e.closest(t);
                  for (var n = e; n && 1 === n.nodeType && !L(n, t);)
                    n = n.parentElement;
                  return n;
                })(t, "." + vt) === l
                ? t
                : void 0;
            }
            function E(e) {
              return [
                e + "--" + n.type,
                e + "--" + n.direction,
                n.drag && e + "--draggable",
                n.isNavigation && e + "--nav",
                e === vt && Mt,
              ];
            }
            return O(f, {
              setup: y,
              mount: function () {
                (s(xe, g),
                  s(xe, y),
                  s(Ae, b),
                  c(
                    document,
                    zt + " keydown",
                    function (e) {
                      o = "keydown" === e.type;
                    },
                    { capture: !0 },
                  ),
                  c(l, "focusin", function () {
                    C(l, jt, !!o);
                  }));
              },
              destroy: g,
            });
          },
          Slides: function (e, t, n) {
            var i = We(e),
              r = i.on,
              o = i.emit,
              a = i.bind,
              s = t.Elements,
              c = s.slides,
              d = s.list,
              f = [];
            function h() {
              c.forEach(function (e, t) {
                v(e, t, -1);
              });
            }
            function p() {
              (b(function (e) {
                e.destroy();
              }),
                u(f));
            }
            function v(t, n, i) {
              var r = Ht(e, n, i, t);
              (r.mount(),
                f.push(r),
                f.sort(function (e, t) {
                  return e.index - t.index;
                }));
            }
            function y(e) {
              return e
                ? w(function (e) {
                    return !e.isClone;
                  })
                : f;
            }
            function b(e, t) {
              y(t).forEach(e);
            }
            function w(e) {
              return f.filter(
                m(e)
                  ? e
                  : function (t) {
                      return g(e) ? L(t.slide, e) : S(k(e), t.index);
                    },
              );
            }
            return {
              mount: function () {
                (h(), r(xe, p), r(xe, h));
              },
              destroy: p,
              update: function () {
                b(function (e) {
                  e.update();
                });
              },
              register: v,
              get: y,
              getIn: function (e) {
                var i = t.Controller,
                  r = i.toIndex(e),
                  o = i.hasFocus() ? 1 : n.perPage;
                return w(function (e) {
                  return le(e.index, r, r + o - 1);
                });
              },
              getAt: function (e) {
                return w(e)[0];
              },
              add: function (e, t) {
                (P(e, function (e) {
                  if ((g(e) && (e = X(e)), E(e))) {
                    var i = c[t];
                    (i ? T(e, i) : A(d, e),
                      x(e, n.classes.slide),
                      (r = e),
                      (s = l(o, Te)),
                      (u = Q(r, "img")),
                      (f = u.length)
                        ? u.forEach(function (e) {
                            a(e, "load error", function () {
                              --f || s();
                            });
                          })
                        : s());
                  }
                  var r, s, u, f;
                }),
                  o(xe));
              },
              remove: function (e) {
                (U(
                  w(e).map(function (e) {
                    return e.slide;
                  }),
                ),
                  o(xe));
              },
              forEach: b,
              filter: w,
              style: function (e, t, n) {
                b(function (i) {
                  i.style(e, t, n);
                });
              },
              getLength: function (e) {
                return e ? c.length : f.length;
              },
              isEnough: function () {
                return f.length > n.perPage;
              },
            };
          },
          Layout: function (e, t, n) {
            var i,
              r,
              o,
              a = We(e),
              s = a.on,
              u = a.bind,
              c = a.emit,
              d = t.Slides,
              f = t.Direction.resolve,
              h = t.Elements,
              p = h.root,
              y = h.track,
              m = h.list,
              g = d.getAt,
              b = d.style;
            function w() {
              ((i = n.direction === Ge),
                q(p, "maxWidth", ee(n.width)),
                q(y, f("paddingLeft"), k(!1)),
                q(y, f("paddingRight"), k(!0)),
                E(!0));
            }
            function E(e) {
              var t = H(p);
              (e || r.width !== t.width || r.height !== t.height) &&
                (q(
                  y,
                  "height",
                  (function () {
                    var e = "";
                    i &&
                      (ie((e = P()), "height or heightRatio is missing."),
                      (e = "calc(" + e + " - " + k(!1) + " - " + k(!0) + ")"));
                    return e;
                  })(),
                ),
                b(f("marginRight"), ee(n.gap)),
                b(
                  "width",
                  n.autoWidth ? null : ee(n.fixedWidth) || (i ? "" : S()),
                ),
                b(
                  "height",
                  ee(n.fixedHeight) || (i ? (n.autoHeight ? null : S()) : P()),
                  !0,
                ),
                (r = t),
                c(Le),
                o !== (o = M()) && (C(p, Rt, o), c("overflow", o)));
            }
            function k(e) {
              var t = n.padding,
                i = f(e ? "right" : "left");
              return (t && ee(t[i] || (v(t) ? 0 : t))) || "0px";
            }
            function P() {
              return ee(n.height || H(m).width * n.heightRatio);
            }
            function S() {
              var e = ee(n.gap);
              return (
                "calc((100%" +
                (e && " + " + e) +
                ")/" +
                (n.perPage || 1) +
                (e && " - " + e) +
                ")"
              );
            }
            function _() {
              return H(m)[f("width")];
            }
            function x(e, t) {
              var n = g(e || 0);
              return n ? H(n.slide)[f("width")] + (t ? 0 : L()) : 0;
            }
            function A(e, t) {
              var n = g(e);
              if (n) {
                var i = H(n.slide)[f("right")],
                  r = H(m)[f("left")];
                return ue(i - r) + (t ? 0 : L());
              }
              return 0;
            }
            function T(t) {
              return A(e.length - 1) - A(0) + x(0, t);
            }
            function L() {
              var e = g(0);
              return (e && parseFloat(q(e.slide, f("marginRight")))) || 0;
            }
            function M() {
              return e.is(Yt) || T(!0) > _();
            }
            return {
              mount: function () {
                var e, t, n;
                (w(),
                  u(
                    window,
                    "resize load",
                    ((e = l(c, Te)),
                    (n = Be(t || 0, e, null, 1)),
                    function () {
                      n.isPaused() && n.start();
                    }),
                  ),
                  s([Ae, xe], w),
                  s(Te, E));
              },
              resize: E,
              listSize: _,
              slideSize: x,
              sliderSize: T,
              totalSize: A,
              getPadding: function (e) {
                return (
                  parseFloat(q(y, f("padding" + (e ? "Right" : "Left")))) || 0
                );
              },
              isOverflow: M,
            };
          },
          Clones: function (e, t, n) {
            var i,
              r = We(e),
              o = r.on,
              a = t.Elements,
              s = t.Slides,
              c = t.Direction.resolve,
              l = [];
            function d() {
              (o(xe, f),
                o([Ae, Te], p),
                (i = v()) &&
                  (!(function (t) {
                    var i = s.get().slice(),
                      r = i.length;
                    if (r) {
                      for (; i.length < t;) _(i, i);
                      _(i.slice(-t), i.slice(0, t)).forEach(function (o, u) {
                        var c = u < t,
                          d = (function (t, i) {
                            var r = t.cloneNode(!0);
                            return (
                              x(r, n.classes.clone),
                              (r.id = e.root.id + "-clone" + pe(i + 1)),
                              r
                            );
                          })(o.slide, u);
                        (c ? T(d, i[0].slide) : A(a.list, d),
                          _(l, d),
                          s.register(d, u - t + (c ? 0 : r), o.index));
                      });
                    }
                  })(i),
                  t.Layout.resize(!0)));
            }
            function f() {
              (h(), d());
            }
            function h() {
              (U(l), u(l), r.destroy());
            }
            function p() {
              var e = v();
              i !== e && (i < e || !e) && r.emit(xe);
            }
            function v() {
              var i = n.clones;
              if (e.is($t)) {
                if (b(i)) {
                  var r = n[c("fixedWidth")] && t.Layout.slideSize(0);
                  i =
                    (r && se(H(a.track)[c("width")] / r)) ||
                    (n[c("autoWidth")] && e.length) ||
                    2 * n.perPage;
                }
              } else i = 0;
              return i;
            }
            return { mount: d, destroy: h };
          },
          Move: function (e, t, n) {
            var i,
              r = We(e),
              a = r.on,
              s = r.emit,
              u = e.state.set,
              c = t.Layout,
              l = c.slideSize,
              d = c.getPadding,
              f = c.totalSize,
              h = c.listSize,
              p = c.sliderSize,
              v = t.Direction,
              y = v.resolve,
              m = v.orient,
              g = t.Elements,
              w = g.list,
              E = g.track;
            function k() {
              t.Controller.isBusy() ||
                (t.Scroll.cancel(), P(e.index), t.Slides.update());
            }
            function P(e) {
              S(A(e, !0));
            }
            function S(n, i) {
              if (!e.is(Yt)) {
                var r = i
                  ? n
                  : (function (n) {
                      if (e.is($t)) {
                        var i = x(n),
                          r = i > t.Controller.getEnd();
                        (i < 0 || r) && (n = _(n, r));
                      }
                      return n;
                    })(n);
                (q(w, "transform", "translate" + y("X") + "(" + r + "px)"),
                  n !== r && s(ze));
              }
            }
            function _(e, t) {
              var n = e - L(t),
                i = p();
              return (e -= m(i * (se(ue(n) / i) || 1)) * (t ? 1 : -1));
            }
            function C() {
              (S(T(), !0), i.cancel());
            }
            function x(e) {
              for (
                var n = t.Slides.get(), i = 0, r = 1 / 0, o = 0;
                o < n.length;
                o++
              ) {
                var a = n[o].index,
                  s = ue(A(a, !0) - e);
                if (!(s <= r)) break;
                ((r = s), (i = a));
              }
              return i;
            }
            function A(t, i) {
              var r = m(
                f(t - 1) -
                  (function (e) {
                    var t = n.focus;
                    return "center" === t
                      ? (h() - l(e, !0)) / 2
                      : +t * l(e) || 0;
                  })(t),
              );
              return i
                ? (function (t) {
                    n.trimSpace && e.is(Bt) && (t = de(t, 0, m(p(!0) - h())));
                    return t;
                  })(r)
                : r;
            }
            function T() {
              var e = y("left");
              return H(w)[e] - H(E)[e] + m(d(!1));
            }
            function L(e) {
              return A(e ? t.Controller.getEnd() : 0, !!n.trimSpace);
            }
            return {
              mount: function () {
                ((i = t.Transition), a([ge, Le, Ae, xe], k));
              },
              move: function (e, t, n, r) {
                var a, c;
                (e !== t &&
                  ((a = e > n),
                  (c = m(_(T(), a))),
                  a ? c >= 0 : c <= w[y("scrollWidth")] - H(E)[y("width")]) &&
                  (C(), S(_(T(), e > n), !0)),
                  u(o),
                  s(we, t, n, e),
                  i.start(t, function () {
                    (u(3), s(Ee, t, n, e), r && r());
                  }));
              },
              jump: P,
              translate: S,
              shift: _,
              cancel: C,
              toIndex: x,
              toPosition: A,
              getPosition: T,
              getLimit: L,
              exceededLimit: function (e, t) {
                t = b(t) ? T() : t;
                var n = !0 !== e && m(t) < m(L(!1)),
                  i = !1 !== e && m(t) > m(L(!0));
                return n || i;
              },
              reposition: k,
            };
          },
          Controller: function (e, t, n) {
            var i,
              r,
              s,
              u,
              c = We(e),
              d = c.on,
              f = c.emit,
              h = t.Move,
              p = h.getPosition,
              v = h.getLimit,
              y = h.toPosition,
              m = t.Slides,
              w = m.isEnough,
              E = m.getLength,
              k = n.omitEnd,
              P = e.is($t),
              S = e.is(Bt),
              _ = l(M, !1),
              C = l(M, !0),
              x = n.start || 0,
              A = x;
            function T() {
              ((r = E(!0)), (s = n.perMove), (u = n.perPage), (i = I()));
              var e = de(x, 0, k ? i : r - 1);
              e !== x && ((x = e), h.reposition());
            }
            function L() {
              i !== I() && f(qe);
            }
            function M(e, t) {
              var n = s || (V() ? 1 : u),
                r = N(x + n * (e ? -1 : 1), x, !(s || V()));
              return -1 === r && S && !ce(p(), v(!e), 1)
                ? e
                  ? 0
                  : i
                : t
                  ? r
                  : F(r);
            }
            function N(t, o, a) {
              if (w() || V()) {
                var c = (function (t) {
                  if (S && "move" === n.trimSpace && t !== x)
                    for (
                      var i = p();
                      i === y(t, !0) && le(t, 0, e.length - 1, !n.rewind);
                    )
                      t < x ? --t : ++t;
                  return t;
                })(t);
                (c !== t && ((o = t), (t = c), (a = !1)),
                  t < 0 || t > i
                    ? (t =
                        s || (!le(0, t, o, !0) && !le(i, o, t, !0))
                          ? P
                            ? a
                              ? t < 0
                                ? -(r % u || u)
                                : r
                              : t
                            : n.rewind
                              ? t < 0
                                ? i
                                : 0
                              : -1
                          : O(j(t)))
                    : a && t !== o && (t = O(j(o) + (t < o ? -1 : 1))));
              } else t = -1;
              return t;
            }
            function F(e) {
              return P ? (e + r) % r || 0 : e;
            }
            function I() {
              for (var e = r - (V() || (P && s) ? 1 : u); k && e-- > 0;)
                if (y(r - 1, !0) !== y(e, !0)) {
                  e++;
                  break;
                }
              return de(e, 0, r - 1);
            }
            function O(e) {
              return de(V() ? e : u * e, 0, i);
            }
            function j(e) {
              return V() ? re(e, i) : ae((e >= i ? r - 1 : e) / u);
            }
            function R(e) {
              e !== x && ((A = x), (x = e));
            }
            function V() {
              return !b(n.focus) || n.isNavigation;
            }
            function D() {
              return e.state.is([o, a]) && !!n.waitForTransition;
            }
            return {
              mount: function () {
                (T(), d([Ae, xe, qe], T), d(Le, L));
              },
              go: function (e, t, n) {
                if (!D()) {
                  var r = (function (e) {
                      var t = x;
                      if (g(e)) {
                        var n = e.match(/([+\-<>])(\d+)?/) || [],
                          r = n[1],
                          o = n[2];
                        "+" === r || "-" === r
                          ? (t = N(x + +("" + r + (+o || 1)), x))
                          : ">" === r
                            ? (t = o ? O(+o) : _(!0))
                            : "<" === r && (t = C(!0));
                      } else t = P ? e : de(e, 0, i);
                      return t;
                    })(e),
                    o = F(r);
                  o > -1 && (t || o !== x) && (R(o), h.move(r, o, A, n));
                }
              },
              scroll: function (e, n, r, o) {
                t.Scroll.scroll(e, n, r, function () {
                  var e = F(h.toIndex(p()));
                  (R(k ? re(e, i) : e), o && o());
                });
              },
              getNext: _,
              getPrev: C,
              getAdjacent: M,
              getEnd: I,
              setIndex: R,
              getIndex: function (e) {
                return e ? A : x;
              },
              toIndex: O,
              toPage: j,
              toDest: function (e) {
                var t = h.toIndex(e);
                return S ? de(t, 0, i) : t;
              },
              hasFocus: V,
              isBusy: D,
            };
          },
          Arrows: function (e, t, n) {
            var i,
              r,
              o = We(e),
              a = o.on,
              s = o.bind,
              u = o.emit,
              c = n.classes,
              d = n.i18n,
              f = t.Elements,
              h = t.Controller,
              p = f.arrows,
              v = f.track,
              y = p,
              m = f.prev,
              g = f.next,
              b = {};
            function w() {
              (!(function () {
                var e = n.arrows;
                !e ||
                  (m && g) ||
                  ((y = p || z("div", c.arrows)),
                  (m = S(!0)),
                  (g = S(!1)),
                  (i = !0),
                  A(y, [m, g]),
                  !p && T(y, v));
                m &&
                  g &&
                  (O(b, { prev: m, next: g }),
                  W(y, e ? "" : "none"),
                  x(y, (r = Et + "--" + n.direction)),
                  e &&
                    (a([ge, Ee, xe, Ne, qe], _),
                    s(g, "click", l(P, ">")),
                    s(m, "click", l(P, "<")),
                    _(),
                    D([m, g], tt, v.id),
                    u(Ie, m, g)));
              })(),
                a(Ae, E));
            }
            function E() {
              (k(), w());
            }
            function k() {
              (o.destroy(),
                K(y, r),
                i ? (U(p ? [m, g] : y), (m = g = null)) : V([m, g], ft));
            }
            function P(e) {
              h.go(e, !0);
            }
            function S(e) {
              return X(
                '<button class="' +
                  c.arrow +
                  " " +
                  (e ? c.prev : c.next) +
                  '" type="button"><svg xmlns="' +
                  Ut +
                  '" viewBox="0 0 ' +
                  "40 " +
                  '40" width="' +
                  '40" height="' +
                  '40" focusable="false"><path d="' +
                  (n.arrowPath || Xt) +
                  '" />',
              );
            }
            function _() {
              if (m && g) {
                var t = e.index,
                  n = h.getPrev(),
                  i = h.getNext(),
                  r = n > -1 && t < n ? d.last : d.prev,
                  o = i > -1 && t > i ? d.first : d.next;
                ((m.disabled = n < 0),
                  (g.disabled = i < 0),
                  D(m, rt, r),
                  D(g, rt, o),
                  u("arrows:updated", m, g, n, i));
              }
            }
            return { arrows: b, mount: w, destroy: k, update: _ };
          },
          Autoplay: function (e, t, n) {
            var i,
              r,
              o = We(e),
              a = o.on,
              s = o.bind,
              u = o.emit,
              c = Be(n.interval, e.go.bind(e, ">"), function (e) {
                var t = d.bar;
                (t && q(t, "width", 100 * e + "%"), u("autoplay:playing", e));
              }),
              l = c.isPaused,
              d = t.Elements,
              f = t.Elements,
              h = f.root,
              p = f.toggle,
              v = n.autoplay,
              y = "pause" === v;
            function m() {
              l() &&
                t.Slides.isEnough() &&
                (c.start(!n.resetProgress), (r = i = y = !1), w(), u(je));
            }
            function g(e) {
              (void 0 === e && (e = !0),
                (y = !!e),
                w(),
                l() || (c.pause(), u(Re)));
            }
            function b() {
              y || (i || r ? g(!1) : m());
            }
            function w() {
              p && (C(p, Mt, !y), D(p, rt, n.i18n[y ? "play" : "pause"]));
            }
            function E(e) {
              var i = t.Slides.getAt(e);
              c.set((i && +$(i.slide, Gt)) || n.interval);
            }
            return {
              mount: function () {
                v &&
                  (!(function () {
                    n.pauseOnHover &&
                      s(h, "mouseenter mouseleave", function (e) {
                        ((i = "mouseenter" === e.type), b());
                      });
                    n.pauseOnFocus &&
                      s(h, "focusin focusout", function (e) {
                        ((r = "focusin" === e.type), b());
                      });
                    p &&
                      s(p, "click", function () {
                        y ? m() : g(!0);
                      });
                    (a([we, Me, xe], c.rewind), a(we, E));
                  })(),
                  p && D(p, tt, d.track.id),
                  y || m(),
                  w());
              },
              destroy: c.cancel,
              play: m,
              pause: g,
              isPaused: l,
            };
          },
          Cover: function (e, t, n) {
            var i = We(e).on;
            function r(e) {
              t.Slides.forEach(function (t) {
                var n = N(t.container || t.slide, "img");
                n && n.src && o(e, n, t);
              });
            }
            function o(e, t, n) {
              (n.style(
                "background",
                e ? 'center/cover no-repeat url("' + t.src + '")' : "",
                !0,
              ),
                W(t, e ? "none" : ""));
            }
            return {
              mount: function () {
                n.cover && (i(Ve, l(o, !0)), i([ge, Ae, xe], l(r, !0)));
              },
              destroy: l(r, !1),
            };
          },
          Scroll: function (e, t, n) {
            var i,
              r,
              o = We(e),
              s = o.on,
              u = o.emit,
              c = e.state.set,
              d = t.Move,
              f = d.getPosition,
              h = d.getLimit,
              p = d.exceededLimit,
              v = d.translate,
              y = e.is(Bt),
              m = 1;
            function g(e, n, o, s, h) {
              var v = f();
              if ((E(), o && (!y || !p()))) {
                var g = t.Layout.sliderSize(),
                  k = fe(e) * g * ae(ue(e) / g) || 0;
                e = d.toPosition(t.Controller.toDest(e % g)) + k;
              }
              var P = ce(v, e, 1);
              ((m = 1),
                (n = P ? 0 : n || oe(ue(e - v) / 1.5, 800)),
                (r = s),
                (i = Be(n, b, l(w, v, e, h), 1)),
                c(a),
                u(Me),
                i.start());
            }
            function b() {
              (c(3), r && r(), u(Ne));
            }
            function w(e, t, i, o) {
              var a,
                s,
                u = f(),
                c =
                  (e +
                    (t - e) *
                      ((a = o),
                      (s = n.easingFunc) ? s(a) : 1 - Math.pow(1 - a, 4)) -
                    u) *
                  m;
              (v(u + c),
                y &&
                  !i &&
                  p() &&
                  ((m *= 0.6), ue(c) < 10 && g(h(p(!0)), 600, !1, r, !0)));
            }
            function E() {
              i && i.cancel();
            }
            function k() {
              i && !i.isPaused() && (E(), b());
            }
            return {
              mount: function () {
                (s(we, E), s([Ae, xe], k));
              },
              destroy: E,
              scroll: g,
              cancel: k,
            };
          },
          Drag: function (e, t, n) {
            var i,
              r,
              s,
              u,
              c,
              l,
              d,
              h,
              p = We(e),
              y = p.on,
              m = p.emit,
              g = p.bind,
              b = p.unbind,
              w = e.state,
              E = t.Move,
              k = t.Scroll,
              P = t.Controller,
              S = t.Elements.track,
              _ = t.Media.reduce,
              C = t.Direction,
              x = C.resolve,
              A = C.orient,
              T = E.getPosition,
              M = E.exceededLimit,
              N = !1;
            function F() {
              var e = n.drag;
              ($(!e), (u = "free" === e));
            }
            function I(e) {
              if (((l = !1), !d)) {
                var t = B(e);
                ((i = e.target),
                  (r = n.noDrag),
                  L(i, "." + Ct + ", ." + kt) ||
                    (r && L(i, r)) ||
                    (!t && e.button) ||
                    (P.isBusy()
                      ? G(e, !0)
                      : ((h = t ? S : window),
                        (c = w.is([o, a])),
                        (s = null),
                        g(h, qt, O, Jt),
                        g(h, Wt, j, Jt),
                        E.cancel(),
                        k.cancel(),
                        V(e))));
              }
              var i, r;
            }
            function O(t) {
              if ((w.is(6) || (w.set(6), m("drag")), t.cancelable))
                if (c) {
                  E.translate(i + D(t) / (N && e.is(Bt) ? 5 : 1));
                  var r = z(t) > 200,
                    o = N !== (N = M());
                  ((r || o) && V(t), (l = !0), m("dragging"), G(t));
                } else
                  (function (e) {
                    return ue(D(e)) > ue(D(e, !0));
                  })(t) &&
                    ((c = (function (e) {
                      var t = n.dragMinThreshold,
                        i = v(t),
                        r = (i && t.mouse) || 0,
                        o = (i ? t.touch : +t) || 10;
                      return ue(D(e)) > (B(e) ? o : r);
                    })(t)),
                    G(t));
            }
            function j(i) {
              (w.is(6) && (w.set(3), m("dragged")),
                c &&
                  (!(function (i) {
                    var r = (function (t) {
                        if (e.is($t) || !N) {
                          var n = z(t);
                          if (n && n < 200) return D(t) / n;
                        }
                        return 0;
                      })(i),
                      o = (function (e) {
                        return (
                          T() +
                          fe(e) *
                            re(
                              ue(e) * (n.flickPower || 600),
                              u
                                ? 1 / 0
                                : t.Layout.listSize() * (n.flickMaxPages || 1),
                            )
                        );
                      })(r),
                      a = n.rewind && n.rewindByDrag;
                    (_(!1),
                      u
                        ? P.scroll(o, 0, n.snap)
                        : e.is(Yt)
                          ? P.go(A(fe(r)) < 0 ? (a ? "<" : "-") : a ? ">" : "+")
                          : e.is(Bt) && N && a
                            ? P.go(M(!0) ? ">" : "<")
                            : P.go(P.toDest(o), !0));
                    _(!0);
                  })(i),
                  G(i)),
                b(h, qt, O),
                b(h, Wt, j),
                (c = !1));
            }
            function R(e) {
              !d && l && G(e, !0);
            }
            function V(e) {
              ((s = r), (r = e), (i = T()));
            }
            function D(e, t) {
              return W(e, t) - W(q(e), t);
            }
            function z(e) {
              return Z(e) - Z(q(e));
            }
            function q(e) {
              return (r === e && s) || r;
            }
            function W(e, t) {
              return (B(e) ? e.changedTouches[0] : e)[
                "page" + x(t ? "Y" : "X")
              ];
            }
            function B(e) {
              return (
                "undefined" != typeof TouchEvent && e instanceof TouchEvent
              );
            }
            function $(e) {
              d = e;
            }
            return {
              mount: function () {
                (g(S, qt, f, Jt),
                  g(S, Wt, f, Jt),
                  g(S, zt, I, Jt),
                  g(S, "click", R, { capture: !0 }),
                  g(S, "dragstart", G),
                  y([ge, Ae], F));
              },
              disable: $,
              isDragging: function () {
                return c;
              },
            };
          },
          Keyboard: function (e, t, n) {
            var i,
              r,
              o = We(e),
              a = o.on,
              s = o.bind,
              u = o.unbind,
              c = e.root,
              l = t.Direction.resolve;
            function f() {
              var e = n.keyboard;
              e && ((i = "global" === e ? window : c), s(i, Zt, v));
            }
            function h() {
              u(i, Zt);
            }
            function p() {
              var e = r;
              ((r = !0),
                d(function () {
                  r = e;
                }));
            }
            function v(t) {
              if (!r) {
                var n = Kt(t);
                n === l(Ye) ? e.go("<") : n === l(He) && e.go(">");
              }
            }
            return {
              mount: function () {
                (f(), a(Ae, h), a(Ae, f), a(we, p));
              },
              destroy: h,
              disable: function (e) {
                r = e;
              },
            };
          },
          LazyLoad: function (e, t, n) {
            var i = We(e),
              r = i.on,
              o = i.off,
              a = i.bind,
              s = i.emit,
              c = "sequential" === n.lazyLoad,
              d = [Ee, Ne],
              f = [];
            function h() {
              (u(f),
                t.Slides.forEach(function (e) {
                  Q(e.slide, nn).forEach(function (t) {
                    var i = $(t, en),
                      r = $(t, tn);
                    if (i !== t.src || r !== t.srcset) {
                      var o = n.classes.spinner,
                        a = t.parentElement,
                        s = N(a, "." + o) || z("span", o, a);
                      (f.push([t, e, s]), t.src || W(t, "none"));
                    }
                  });
                }),
                c ? m() : (o(d), r(d, p), p()));
            }
            function p() {
              (f = f.filter(function (t) {
                var i = n.perPage * ((n.preloadPages || 1) + 1) - 1;
                return !t[1].isWithin(e.index, i) || v(t);
              })).length || o(d);
            }
            function v(e) {
              var t = e[0];
              (x(e[1].slide, Ot),
                a(t, "load error", l(y, e)),
                D(t, "src", $(t, en)),
                D(t, "srcset", $(t, tn)),
                V(t, en),
                V(t, tn));
            }
            function y(e, t) {
              var n = e[0],
                i = e[1];
              (K(i.slide, Ot),
                "error" !== t.type && (U(e[2]), W(n, ""), s(Ve, n, i), s(Te)),
                c && m());
            }
            function m() {
              f.length && v(f.shift());
            }
            return {
              mount: function () {
                n.lazyLoad && (h(), r(xe, h));
              },
              destroy: l(u, f),
              check: p,
            };
          },
          Pagination: function (e, t, n) {
            var i,
              r,
              o = We(e),
              a = o.on,
              s = o.emit,
              d = o.bind,
              f = t.Slides,
              h = t.Elements,
              p = t.Controller,
              v = p.hasFocus,
              y = p.getIndex,
              m = p.go,
              g = t.Direction.resolve,
              b = h.pagination,
              w = [];
            function E() {
              (i && (U(b ? c(i.children) : i), K(i, r), u(w), (i = null)),
                o.destroy());
            }
            function k(e) {
              m(">" + e, !0);
            }
            function P(e, t) {
              var n = w.length,
                i = Kt(t),
                r = S(),
                o = -1;
              i === g(He, !1, r)
                ? (o = ++e % n)
                : i === g(Ye, !1, r)
                  ? (o = (--e + n) % n)
                  : "Home" === i
                    ? (o = 0)
                    : "End" === i && (o = n - 1);
              var a = w[o];
              a && (B(a.button), m(">" + o), G(t, !0));
            }
            function S() {
              return n.paginationDirection || n.direction;
            }
            function _(e) {
              return w[p.toPage(e)];
            }
            function C() {
              var e = _(y(!0)),
                t = _(y());
              if (e) {
                var n = e.button;
                (K(n, Mt), V(n, it), D(n, Ze, -1));
              }
              if (t) {
                var r = t.button;
                (x(r, Mt), D(r, it, !0), D(r, Ze, ""));
              }
              s("pagination:updated", { list: i, items: w }, e, t);
            }
            return {
              items: w,
              mount: function t() {
                (E(), a([Ae, xe, qe], t));
                var o = n.pagination;
                (b && W(b, o ? "" : "none"),
                  o &&
                    (a([we, Me, Ne], C),
                    (function () {
                      var t = e.length,
                        o = n.classes,
                        a = n.i18n,
                        s = n.perPage,
                        u = v() ? p.getEnd() + 1 : se(t / s);
                      (x(
                        (i = b || z("ul", o.pagination, h.track.parentElement)),
                        (r = _t + "--" + S()),
                      ),
                        D(i, Ke, "tablist"),
                        D(i, rt, a.select),
                        D(i, st, S() === Ge ? "vertical" : ""));
                      for (var c = 0; c < u; c++) {
                        var y = z("li", null, i),
                          m = z("button", { class: o.page, type: "button" }, y),
                          g = f.getIn(c).map(function (e) {
                            return e.slide.id;
                          }),
                          E = !v() && s > 1 ? a.pageX : a.slideX;
                        (d(m, "click", l(k, c)),
                          n.paginationKeyboard && d(m, "keydown", l(P, c)),
                          D(y, Ke, "presentation"),
                          D(m, Ke, "tab"),
                          D(m, tt, g.join(" ")),
                          D(m, rt, he(E, c + 1)),
                          D(m, Ze, -1),
                          w.push({ li: y, button: m, page: c }));
                      }
                    })(),
                    C(),
                    s(
                      "pagination:mounted",
                      { list: i, items: w },
                      _(e.index),
                    )));
              },
              destroy: E,
              getAt: _,
              update: C,
            };
          },
          Sync: function (e, t, n) {
            var i = n.isNavigation,
              r = n.slideFocus,
              o = [];
            function a() {
              var t, n;
              (e.splides.forEach(function (t) {
                t.isParent || (c(e, t.splide), c(t.splide, e));
              }),
                i &&
                  ((t = We(e)),
                  (n = t.on)(ke, f),
                  n(De, h),
                  n([ge, Ae], d),
                  o.push(t),
                  t.emit(Oe, e.splides)));
            }
            function s() {
              (o.forEach(function (e) {
                e.destroy();
              }),
                u(o));
            }
            function c(e, t) {
              var n = We(e);
              (n.on(we, function (e, n, i) {
                t.go(t.is($t) ? i : e);
              }),
                o.push(n));
            }
            function d() {
              D(t.Elements.list, st, n.direction === Ge ? "vertical" : "");
            }
            function f(t) {
              e.go(t.index);
            }
            function h(e, t) {
              S(rn, Kt(t)) && (f(e), G(t));
            }
            return {
              setup: l(t.Media.set, { slideFocus: b(r) ? i : r }, !0),
              mount: a,
              destroy: s,
              remount: function () {
                (s(), a());
              },
            };
          },
          Wheel: function (e, t, n) {
            var i = We(e).bind,
              r = 0;
            function a(i) {
              if (i.cancelable) {
                var a = i.deltaY,
                  s = a < 0,
                  u = Z(i),
                  c = n.wheelMinThreshold || 0,
                  l = n.wheelSleep || 0;
                (ue(a) > c && u - r > l && (e.go(s ? "<" : ">"), (r = u)),
                  (function (i) {
                    return (
                      !n.releaseWheel ||
                      e.state.is(o) ||
                      -1 !== t.Controller.getAdjacent(i)
                    );
                  })(s) && G(i));
              }
            }
            return {
              mount: function () {
                n.wheel && i(t.Elements.track, "wheel", a, Jt);
              },
            };
          },
          Live: function (e, t, n) {
            var i = We(e).on,
              r = t.Elements.track,
              o = n.live && !n.isNavigation,
              a = z("span", Tt),
              s = Be(90, l(u, !1));
            function u(e) {
              (D(r, lt, e), e ? (A(r, a), s.start()) : (U(a), s.cancel()));
            }
            function c(e) {
              o && D(r, ct, e ? "off" : "polite");
            }
            return {
              mount: function () {
                o &&
                  (c(!t.Autoplay.isPaused()),
                  D(r, dt, !0),
                  (a.textContent = "…"),
                  i(je, l(c, !0)),
                  i(Re, l(c, !1)),
                  i([Ee, Ne], l(u, !0)));
              },
              disable: c,
              destroy: function () {
                (V(r, [ct, dt, lt]), U(a));
              },
            };
          },
        }),
        an = {
          type: "slide",
          role: "region",
          speed: 400,
          perPage: 1,
          cloneStatus: !0,
          arrows: !0,
          pagination: !0,
          paginationKeyboard: !0,
          interval: 5e3,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          resetProgress: !0,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          drag: !0,
          direction: "ltr",
          trimSpace: !0,
          focusableNodes: "a, button, textarea, input, select, iframe",
          live: !0,
          classes: Dt,
          i18n: {
            prev: "Previous slide",
            next: "Next slide",
            first: "Go to first slide",
            last: "Go to last slide",
            slideX: "Go to slide %s",
            pageX: "Go to page %s",
            play: "Start autoplay",
            pause: "Pause autoplay",
            carousel: "carousel",
            slide: "slide",
            select: "Select a slide to show",
            slideLabel: "%s of %s",
          },
          reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: "pause" },
        };
      function sn(e, t, n) {
        var i = t.Slides;
        function r() {
          i.forEach(function (e) {
            e.style("transform", "translateX(-" + 100 * e.index + "%)");
          });
        }
        return {
          mount: function () {
            We(e).on([ge, xe], r);
          },
          start: function (e, t) {
            (i.style("transition", "opacity " + n.speed + "ms " + n.easing),
              d(t));
          },
          cancel: f,
        };
      }
      function un(e, t, n) {
        var i,
          r = t.Move,
          o = t.Controller,
          a = t.Scroll,
          s = t.Elements.list,
          u = l(q, s, "transition");
        function c() {
          (u(""), a.cancel());
        }
        return {
          mount: function () {
            We(e).bind(s, "transitionend", function (e) {
              e.target === s && i && (c(), i());
            });
          },
          start: function (t, s) {
            var c = r.toPosition(t, !0),
              l = r.getPosition(),
              d = (function (t) {
                var i = n.rewindSpeed;
                if (e.is(Bt) && i) {
                  var r = o.getIndex(!0),
                    a = o.getEnd();
                  if ((0 === r && t >= a) || (r >= a && 0 === t)) return i;
                }
                return n.speed;
              })(t);
            ue(c - l) >= 1 && d >= 1
              ? n.useScroll
                ? a.scroll(c, d, !1, s)
                : (u("transform " + d + "ms " + n.easing),
                  r.translate(c, !0),
                  (i = s))
              : (r.jump(t), s());
          },
          cancel: c,
        };
      }
      var cn = (function () {
        function e(t, n) {
          var i;
          ((this.event = We()),
            (this.Components = {}),
            (this.state =
              ((i = 1),
              {
                set: function (e) {
                  i = e;
                },
                is: function (e) {
                  return S(k(e), i);
                },
              })),
            (this.splides = []),
            (this._o = {}),
            (this._E = {}));
          var r = g(t) ? J(document, t) : t;
          (ie(r, r + " is invalid."),
            (this.root = r),
            (n = j(
              { label: $(r, rt) || "", labelledby: $(r, ot) || "" },
              an,
              e.defaults,
              n || {},
            )));
          try {
            j(n, JSON.parse($(r, ne)));
          } catch (e) {
            ie(!1, "Invalid JSON");
          }
          this._o = Object.create(j({}, n));
        }
        var t,
          n,
          r,
          o = e.prototype;
        return (
          (o.mount = function (e, t) {
            var n = this,
              i = this.state,
              r = this.Components;
            return (
              ie(i.is([1, 7]), "Already mounted!"),
              i.set(1),
              (this._C = r),
              (this._T = t || this._T || (this.is(Yt) ? sn : un)),
              (this._E = e || this._E),
              I(O({}, on, this._E, { Transition: this._T }), function (e, t) {
                var i = e(n, r, n._o);
                ((r[t] = i), i.setup && i.setup());
              }),
              I(r, function (e) {
                e.mount && e.mount();
              }),
              this.emit(ge),
              x(this.root, Lt),
              i.set(3),
              this.emit(be),
              this
            );
          }),
          (o.sync = function (e) {
            return (
              this.splides.push({ splide: e }),
              e.splides.push({ splide: this, isParent: !0 }),
              this.state.is(3) &&
                (this._C.Sync.remount(), e.Components.Sync.remount()),
              this
            );
          }),
          (o.go = function (e) {
            return (this._C.Controller.go(e), this);
          }),
          (o.on = function (e, t) {
            return (this.event.on(e, t), this);
          }),
          (o.off = function (e) {
            return (this.event.off(e), this);
          }),
          (o.emit = function (e) {
            var t;
            return (
              (t = this.event).emit.apply(t, [e].concat(c(arguments, 1))),
              this
            );
          }),
          (o.add = function (e, t) {
            return (this._C.Slides.add(e, t), this);
          }),
          (o.remove = function (e) {
            return (this._C.Slides.remove(e), this);
          }),
          (o.is = function (e) {
            return this._o.type === e;
          }),
          (o.refresh = function () {
            return (this.emit(xe), this);
          }),
          (o.destroy = function (e) {
            void 0 === e && (e = !0);
            var t = this.event,
              n = this.state;
            return (
              n.is(1)
                ? We(this).on(be, this.destroy.bind(this, e))
                : (I(
                    this._C,
                    function (t) {
                      t.destroy && t.destroy(e);
                    },
                    !0,
                  ),
                  t.emit(Fe),
                  t.destroy(),
                  e && u(this.splides),
                  n.set(7)),
              this
            );
          }),
          (t = e),
          (n = [
            {
              key: "options",
              get: function () {
                return this._o;
              },
              set: function (e) {
                this._C.Media.set(e, !0, !0);
              },
            },
            {
              key: "length",
              get: function () {
                return this._C.Slides.getLength(!0);
              },
            },
            {
              key: "index",
              get: function () {
                return this._C.Controller.getIndex();
              },
            },
          ]) && i(t.prototype, n),
          r && i(t, r),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      ((cn.defaults = {}), (cn.STATES = s));
    },
  },
]);
